// import React, { useState, useEffect, useRef } from 'react';
// import katex from 'katex';
// import 'katex/dist/katex.min.css';
// import he from 'he';
// import { FULL_API_BASE_URL } from "../../Config/Config";
// const TestPrintModal = ({ isOpen, onClose, testScheduleId, selectedSet = 'A' }) => {
//     const [questionData, setQuestionData] = useState(null);
//     const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//     const [status, setStatus] = useState('Ready');
//     const [isLoading, setIsLoading] = useState(false);

//     // ✅ Use ref to track if we should auto-print after data loads
//     const shouldAutoPrint = useRef(false);

//     const [printOptions, setPrintOptions] = useState({
//         selectedSet: selectedSet,
//         coverPage: false,
//         twinColumn: true,
//         watermark: true,
//         roughWork: false
//     });

//     // Update selectedSet when prop changes
//     useEffect(() => {
//         setPrintOptions(prev => ({ ...prev, selectedSet }));
//     }, [selectedSet]);

//     // Close modal on Escape key
//     useEffect(() => {
//         const handleEscape = (e) => {
//             if (e.key === 'Escape') onClose();
//         };

//         if (isOpen) {
//             document.addEventListener('keydown', handleEscape);
//             document.body.style.overflow = 'hidden';
//         }

//         return () => {
//             document.removeEventListener('keydown', handleEscape);
//             document.body.style.overflow = 'unset';
//         };
//     }, [isOpen, onClose]);

//     // ✅ Auto-print when data is loaded and flag is set
//     useEffect(() => {
//         if (shouldAutoPrint.current && questionData && quesPaperInfo) {
//             shouldAutoPrint.current = false;
//             // Small delay to ensure DOM is ready
//             setTimeout(() => {
//                 handlePrint();
//             }, 100);
//         }
//     }, [questionData, quesPaperInfo]);

//     // Helper function to decode HTML entities and render LaTeX + images to HTML
//     // const renderToHTML = (text) => {
//     //     if (!text) return '';

//     //     const decoded = he.decode(text);
//     //     const parts = decoded.split(/(imgsrc=[^ ]+)/g);

//     //     return parts.map(segment => {
//     //         if (segment.startsWith('imgsrc=')) {
//     //             const url = segment.replace('imgsrc=', '');
//     //             return `<img src="${url}" alt="image" style="width: auto; height: auto; min-width: 50px; min-height: 50px; max-width: 90%; vertical-align: middle; margin: 3px; object-fit: contain;" />`;
//     //         } else {
//     //             return segment.replace(/\\\((.*?)\\\)/g, (match, math) => {
//     //                 try {
//     //                     return katex.renderToString(math, {
//     //                         throwOnError: false,
//     //                         displayMode: false
//     //                     });
//     //                 } catch (e) {
//     //                     console.warn('KaTeX error:', e);
//     //                     return `<span style="color: red;">[LaTeX Error: ${math}]</span>`;
//     //                 }
//     //             });
//     //         }
//     //     }).join('');
//     // };
//     // Helper function to decode HTML entities and render LaTeX + images to HTML
//     const renderToHTML = (text) => {
//         if (!text) return '';

//         const decoded = he.decode(text);

//         // ✅ First extract and placeholder images to protect them
//         const imagePlaceholders = [];
//         let processedText = decoded.replace(/(imgsrc=[^ ]+)/g, (match) => {
//             const placeholder = `__IMAGE_${imagePlaceholders.length}__`;
//             imagePlaceholders.push(match);
//             return placeholder;
//         });

//         // ✅ Process LaTeX with improved regex - supports both \(...\) and \[...\]
//         processedText = processedText.replace(/\\\[([\s\S]*?)\\\]|\\\(([\s\S]*?)\\\)/g, (match, displayMath, inlineMath) => {
//             const math = displayMath || inlineMath;
//             const isDisplay = !!displayMath;

//             try {
//                 return katex.renderToString(math, {
//                     throwOnError: false,
//                     displayMode: isDisplay
//                 });
//             } catch (e) {
//                 console.warn('KaTeX error:', e, 'Math:', math);
//                 return `<span style="color: red;">[LaTeX Error]</span>`;
//             }
//         });

//         // ✅ Restore images from placeholders
//         processedText = processedText.replace(/__IMAGE_(\d+)__/g, (match, index) => {
//             const imgSrc = imagePlaceholders[parseInt(index)];
//             const url = imgSrc.replace('imgsrc=', '');
//             return `<img src="${url}" alt="image" loading="eager" fetchpriority="high" style="width: auto; height: auto; min-width: 50px; min-height: 50px; max-width: 90%; vertical-align: middle; margin: 3px; object-fit: contain;" />`;
//         });

//         return processedText;
//     };

//     // Get option label based on pattern
//     const getOptionLabel = (index, pattern) => {
//         if (pattern === 1) return `${index + 1}.`;
//         if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//         if (pattern === 3) {
//             const roman = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x'];
//             return roman[index] || `${index + 1}.`;
//         }
//         return `${index + 1}.`;
//     };

//     // ✅ Fetch question data from API
//     const fetchQuestionData = async () => {
//         try {
//             setStatus('Fetching data...');
//             setIsLoading(true);

//             const accessToken = localStorage.getItem('other') || '';

//             let setParams = '';
//             if (printOptions.selectedSet === 'All') {
//                 setParams = 'set_names=A&set_names=B&set_names=C&set_names=D';
//             } else {
//                 setParams = `set_names=${printOptions.selectedSet}`;
//             }

//             // const url = `${FULL_API_BASE_URL}/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`;

//             const url = `${FULL_API_BASE_URL}/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`;

//             const response = await fetch(url, {
//                 headers: {
//                     'Authorization': `Bearer ${accessToken}`,
//                     'accept': 'application/json'
//                 }
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const data = await response.json();
//             setQuestionData(data.sets || []);
//             setQuesPaperInfo(data.ques_paper_info || null);

//             const totalQuestions = data.sets[0]?.subjects?.reduce((sum, subj) =>
//                 sum + subj.sections.reduce((s, sec) => s + sec.questions.length, 0), 0) || 0;

//             setStatus(`Data fetched successfully! Questions: ${totalQuestions}`);
//             setIsLoading(false);

//             return { success: true };
//         } catch (error) {
//             console.error('Error fetching data:', error);
//             setStatus(`Error: ${error.message}`);
//             setIsLoading(false);
//             shouldAutoPrint.current = false; // ✅ Cancel auto-print on error
//             alert(`Failed to fetch data: ${error.message}`);
//             return { success: false };
//         }
//     };

//     // ✅ Generate Cover Page HTML
//     // const generateCoverPageHTML = () => {
//     //     if (!quesPaperInfo) return '';

//     //     const rawDate = quesPaperInfo.header?.date || '';
//     //     const date = rawDate.split(',').slice(0, 2).join(',').trim() || rawDate;
//     //     const testName = quesPaperInfo.header?.test_name || '';

//     //     return `
//     //   <div class="cover-page">
//     //     <div class="cover-content">
//     //       <h1 class="cover-title">DEFINITE SUCCESS</h1>
//     //       <h2 class="cover-test-name">${testName}</h2>
//     //       <p class="cover-date">${date}</p>
//     //       <p class="cover-set">SET: ${printOptions.selectedSet}</p>
//     //     </div>
//     //   </div>
//     // `;
//     // };

//     // ✅ Generate Rough Work Pages HTML
//     const generateRoughWorkHTML = () => {
//         return `
//       <div class="rough-work-page">
//         <h2 class="rough-work-title">ROUGH WORK</h2>
//         <div class="rough-work-lines"></div>
//       </div>
//       <div class="rough-work-page">
//         <h2 class="rough-work-title">ROUGH WORK</h2>
//         <div class="rough-work-lines"></div>
//       </div>
//     `;
//     };

//     // ✅ SINGLE COLUMN
//     const generateSingleColumnPrintHTML = () => {
//         if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//             return '<p>No data available to print</p>';
//         }

//         let html = '';

//         // if (printOptions.coverPage) {
//         //     html += generateCoverPageHTML();
//         // }

//         html += '<div class="print-container single-column">';
//         const set = questionData[0];
//         let questionCounter = 0;

//         set.subjects.forEach((subject, subjectIndex) => {
//             if (subjectIndex > 0) {
//                 html += `<div class="subject-divider"></div>`;
//             }

//             subject.sections.forEach(section => {
//                 // html += `<p class="section-heading">Section ${section.section_name}</p>`;
//                 html += `<p class="section-heading">${subject.subject_name} - Set ${set.set_name} - Section ${section.section_name}</p>`;

//                 if (section.section_instruction?.trim()) {
//                     html += `<p class="section-instruction"><strong>Instruction:</strong> ${renderToHTML(section.section_instruction)}</p>`;
//                 }

//                 const questions = [...section.questions].sort((a, b) => a.set_ques_position - b.set_ques_position);

//                 questions.forEach(question => {
//                     questionCounter++;

//                     html += `
//             <div class="question-block">
//               <p class="question-text"><strong>${questionCounter}.</strong> ${renderToHTML(question.ques_text)}</p>
//               <div class="options">
//           `;

//                     const options = [...question.options].sort((a, b) => a.set_option_position - b.set_option_position);

//                     options.forEach((option, idx) => {
//                         html += `
//               <p class="option-text">
//                 <span>${getOptionLabel(idx, quesPaperInfo.option_naming_pattern)}</span>
//                 ${renderToHTML(option.option_text)}
//               </p>
//             `;
//                     });

//                     html += `
//               </div>
//             </div>
//           `;
//                 });
//             });
//         });

//         html += '</div>';

//         if (printOptions.roughWork) {
//             html += generateRoughWorkHTML();
//         }

//         return html;
//     };

//     // ✅ TWIN COLUMN
//     const generateTwinColumnPrintHTML = () => {
//         if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//             return '<p>No data available to print</p>';
//         }

//         let html = '';

//         // if (printOptions.coverPage) {
//         //     html += generateCoverPageHTML();
//         // }

//         html += '<div class="print-container twin-column">';
//         const set = questionData[0];
//         let questionCounter = 0;

//         set.subjects.forEach((subject, subjectIndex) => {
//             if (subjectIndex > 0) {
//                 html += `<div class="subject-divider"></div>`;
//             }

//             subject.sections.forEach(section => {
//                 html += `<div class="section-header-wrapper">`;
//                 // html += `<p class="section-heading">Section ${section.section_name}</p>`;
//                 html += `<p class="section-heading">${subject.subject_name} - Set ${set.set_name} - Section ${section.section_name}</p>`;

//                 if (section.section_instruction?.trim()) {
//                     html += `<p class="section-instruction"><strong>Instruction:</strong> ${renderToHTML(section.section_instruction)}</p>`;
//                 }
//                 html += `</div>`;

//                 html += `<div class="columned-content">`;

//                 const questions = [...section.questions].sort((a, b) => a.set_ques_position - b.set_ques_position);

//                 questions.forEach(question => {
//                     questionCounter++;

//                     html += `<p class="question-text"><strong>${questionCounter}.</strong> ${renderToHTML(question.ques_text)}</p>`;

//                     const options = [...question.options].sort((a, b) => a.set_option_position - b.set_option_position);

//                     options.forEach((option, idx) => {
//                         html += `
//             <p class="option-text">
//               <span>${getOptionLabel(idx, quesPaperInfo.option_naming_pattern)}</span>
//               ${renderToHTML(option.option_text)}
//             </p>
//           `;
//                     });

//                     html += `<div class="question-spacer"></div>`;
//                 });

//                 html += `</div>`;
//             });
//         });

//         html += '</div>';

//         if (printOptions.roughWork) {
//             html += generateRoughWorkHTML();
//         }

//         return html;
//     };

//     // Configure browser header dynamically
//     const configureBrowserHeader = () => {
//         if (questionData && quesPaperInfo) {
//             const rawDate = quesPaperInfo.header?.date || '23 December, 2025';
//             const date = rawDate.split(',').slice(0, 2).join(',').trim() || rawDate.split(' ').slice(0, 3).join(' ');
//             const testName = quesPaperInfo.header?.test_name || 'Test';
//             const subjects = questionData[0]?.subjects?.map(s => s.subject_name).join(' | ') || 'Subject';

//             document.title = `${date}                    ${testName}                    ${subjects}`;
//         }
//     };

//     // Add this helper function to preload images
//     const preloadImages = (html) => {
//         return new Promise((resolve) => {
//             const tempDiv = document.createElement('div');
//             tempDiv.innerHTML = html;

//             const images = tempDiv.getElementsByTagName('img');
//             const imageUrls = Array.from(images).map(img => img.src);

//             if (imageUrls.length === 0) {
//                 resolve();
//                 return;
//             }

//             let loadedCount = 0;
//             const totalImages = imageUrls.length;

//             imageUrls.forEach(url => {
//                 const img = new Image();
//                 img.onload = img.onerror = () => {
//                     loadedCount++;
//                     if (loadedCount === totalImages) {
//                         resolve();
//                     }
//                 };
//                 img.src = url;
//             });

//             // Timeout fallback after 10 seconds
//             setTimeout(() => {
//                 console.warn(`Only ${loadedCount}/${totalImages} images loaded`);
//                 resolve();
//             }, 10000);
//         });
//     };

//     // ✅ Updated handlePrint function
//     const handlePrint = async () => {
//         if (!questionData || !quesPaperInfo) {
//             console.warn('Print attempted but data not ready');
//             return;
//         }

//         setStatus('Preparing print... Loading images...');
//         configureBrowserHeader();

//         const printContent = printOptions.twinColumn
//             ? generateTwinColumnPrintHTML()
//             : generateSingleColumnPrintHTML();

//         // ✅ Preload all images before printing
//         await preloadImages(printContent);
//         setStatus('Images loaded. Opening print dialog...');

//         const printWindow = document.createElement('div');
//         printWindow.id = 'printSectionDynamic';
//         printWindow.innerHTML = printContent;

//         const existingPrint = document.getElementById('printSectionDynamic');
//         if (existingPrint) {
//             document.body.removeChild(existingPrint);
//         }

//         document.body.appendChild(printWindow);

//         setTimeout(() => {
//             window.print();
//             setIsLoading(false);
//             setTimeout(() => {
//                 const element = document.getElementById('printSectionDynamic');
//                 if (element) {
//                     document.body.removeChild(element);
//                 }
//             }, 1000);
//         }, 300);
//     };

//     // ✅ Single click handler - acts like double click internally
//     const fetchAndPrint = async () => {
//         if (!testScheduleId) {
//             alert('Test Schedule ID is required');
//             return;
//         }

//         // ✅ Set flag to auto-print after data loads
//         shouldAutoPrint.current = true;

//         // ✅ Fetch data (useEffect will handle printing automatically)
//         await fetchQuestionData();
//     };

//     if (!isOpen) return null;

//     return (
//         <>
//             {/* Modal Overlay */}
//             <div style={styles.overlay} onClick={onClose}>
//                 {/* Modal Content */}
//                 <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
//                     {/* Header */}
//                     <div style={styles.header}>
//                         <h2 style={styles.title}>Question Paper Print Preview</h2>
//                         <button style={styles.closeButton} onClick={onClose}>
//                             ✕
//                         </button>
//                     </div>

//                     {/* Body */}
//                     <div style={styles.body}>
//                         {/* ✅ Set Selection Radio Buttons */}
//                         <div style={styles.setSelectionContainer}>
//                             <h3 style={styles.sectionTitle}>Select Set</h3>
//                             <div style={styles.radioGroup}>
//                                 {['A', 'B', 'C', 'D', 'All'].map(set => (
//                                     <label key={set} style={styles.radioLabel}>
//                                         <input
//                                             type="radio"
//                                             name="set"
//                                             value={set}
//                                             checked={printOptions.selectedSet === set}
//                                             onChange={(e) => setPrintOptions({ ...printOptions, selectedSet: e.target.value })}
//                                             style={styles.radio}
//                                             disabled={isLoading}
//                                         />
//                                         <span style={styles.radioText}>{set}</span>
//                                     </label>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Print Options */}
//                         <div style={styles.optionsContainer}>
//                             <h3 style={styles.sectionTitle}>Print Options</h3>

//                             <div style={styles.checkboxGroup}>
//                                 {/* <label style={styles.checkboxLabel}>
//                                     <input
//                                         type="checkbox"
//                                         checked={printOptions.coverPage}
//                                         onChange={(e) => setPrintOptions({ ...printOptions, coverPage: e.target.checked })}
//                                         style={styles.checkbox}
//                                         disabled={isLoading}
//                                     />
//                                     Cover Page
//                                 </label> */}

//                                 <label style={styles.checkboxLabel}>
//                                     <input
//                                         type="checkbox"
//                                         checked={printOptions.twinColumn}
//                                         onChange={(e) => setPrintOptions({ ...printOptions, twinColumn: e.target.checked })}
//                                         style={styles.checkbox}
//                                         disabled={isLoading}
//                                     />
//                                     Twin Column
//                                 </label>

//                                 <label style={styles.checkboxLabel}>
//                                     <input
//                                         type="checkbox"
//                                         checked={printOptions.watermark}
//                                         onChange={(e) => setPrintOptions({ ...printOptions, watermark: e.target.checked })}
//                                         style={styles.checkbox}
//                                         disabled={isLoading}
//                                     />
//                                     Watermark
//                                 </label>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Footer */}
//                     <div style={styles.footer}>
//                         <button
//                             onClick={fetchAndPrint}
//                             style={{
//                                 ...styles.printButton,
//                                 opacity: isLoading ? 0.6 : 1,
//                                 cursor: isLoading ? 'not-allowed' : 'pointer',
//                             }}
//                             disabled={isLoading}
//                         >
//                             {isLoading ? (
//                                 <>
//                                     <span style={styles.spinner}>⏳</span> LOADING...
//                                 </>
//                             ) : (
//                                 <>
//                                     <span style={styles.printIcon}>🖨️</span> PRINT
//                                 </>
//                             )}
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* Print Styles */}
//             <style>{`
// @media print {
//   body * { visibility: hidden !important; }
//   #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//   #printSectionDynamic {
//     position: absolute !important;
//     left: 0;
//     top: 0;
//     width: 100%;
//   }

//   ${printOptions.watermark ? `
//   #printSectionDynamic::before {
//     content: "";
//     position: fixed;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     width: 300px;
//     height: 300px;
//     background-image: url('http://localhost:3000/client_logos/dsc_bpl.png');
//     background-size: contain;
//     background-repeat: no-repeat;
//     background-position: center;
//     opacity: 0.8;
//     z-index: 1;
//     pointer-events: none;
//   }
//   ` : ''}
// }

// @page {
//   size: A4;
//   margin: 15mm 10mm;
// }

// /* All other print styles remain the same */
// /* .cover-page {
//   width: 100%;
//   height: 100vh;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   page-break-after: always;
//   text-align: center;
// }

// .cover-content {
//   font-family: 'Times New Roman', serif;
// }

// .cover-title {
//   font-size: 48pt;
//   font-weight: bold;
//   margin-bottom: 40px;
//   color: #000;
// }

// .cover-test-name {
//   font-size: 24pt;
//   margin: 20px 0;
//   color: #333;
// }

// .cover-date {
//   font-size: 18pt;
//   margin: 15px 0;
//   color: #555;
// }

// .cover-set {
//   font-size: 20pt;
//   font-weight: bold;
//   margin-top: 30px;
//   color: #000;
// } */

// .rough-work-page {
//   width: 100%;
//   height: 100vh;
//   page-break-after: always;
//   padding: 40px;
// }

// .rough-work-title {
//   font-family: 'Times New Roman', serif;
//   font-size: 24pt;
//   font-weight: bold;
//   text-align: center;
//   margin-bottom: 30px;
//   border-bottom: 2px solid #000;
//   padding-bottom: 10px;
// }

// .rough-work-lines {
//   height: calc(100% - 80px);
//   background-image: repeating-linear-gradient(
//     transparent,
//     transparent 35px,
//     #ccc 35px,
//     #ccc 36px
//   );
// }

// .print-container {
//   width: 100%;
//   font-family: 'Times New Roman', serif;
//   font-size: 11pt;
//   line-height: 1.4;
//   position: relative;
//   z-index: 2;
// }

// .section-header-wrapper {
//   column-span: all;
//   -webkit-column-span: all;
//   page-break-after: avoid;
// }

// .section-heading {
//   font-size: 13pt;
//   font-weight: 500;
//   margin: 10px 0 5px 0;
//   page-break-after: avoid;
// }

// .section-instruction {
//   margin: 0 0 8px 0;
//   page-break-after: avoid;
// }

// .subject-divider {
//   page-break-before: always;
//   column-span: all;
//   -webkit-column-span: all;
// }

// .single-column .question-block {
//   margin-bottom: 6px;
//   page-break-inside: avoid;
//   break-inside: avoid;
// }

// .single-column .question-text {
//   margin: 0 0 2px 0;
//   line-height: 1.3;
//   page-break-after: avoid;
// }

// .single-column .options {
//   margin-left: 20px;
//   margin-bottom: 0;
// }

// .single-column .option-text {
//   margin: 1px 0;
//   font-size: 10.5pt;
//   line-height: 1.2;
// }

// .twin-column .columned-content {
//   column-count: 2;
//   -webkit-column-count: 2;
//   -moz-column-count: 2;
//   column-gap: 20px;
//   -webkit-column-gap: 20px;
//   -moz-column-gap: 20px;
//   column-rule: 2px solid #000;
//   -webkit-column-rule: 2px solid #000;
//   -moz-column-rule: 2px solid #000;
//   column-fill: auto;
//   -webkit-column-fill: auto;
//   -moz-column-fill: auto;
// }

// .twin-column .question-text {
//   margin: 6px 0 2px 0;
//   line-height: 1.3;
//   font-size: 10.5pt;
//   page-break-after: avoid;
//   break-after: avoid-column;
//   orphans: 2;
//   widows: 2;
//   page-break-inside: avoid;
//   break-inside: avoid;
// }

// .twin-column .option-text {
//   margin: 1px 0 1px 15px;
//   font-size: 10pt;
//   line-height: 1.2;
//   orphans: 2;
//   widows: 2;
// }

// .twin-column .question-spacer {
//   height: 4px;
//   margin: 0;
//   padding: 0;
// }

// .question-block img,
// .options img,
// .question-text img,
// .option-text img {
//   width: auto !important;
//   height: auto !important;
//   min-width: 40px !important;
//   min-height: 40px !important;
//   max-width: 85% !important;
//   margin: 2px !important;
//   vertical-align: middle !important;
//   object-fit: contain !important;
//   page-break-inside: avoid;
// }

// .twin-column img {
//   max-width: 75% !important;
// }

// p {
//   orphans: 2;
//   widows: 2;
// }
// `}</style>
//         </>
//     );
// };

// const styles = {
//     overlay: {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: 'rgba(0, 0, 0, 0.7)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         zIndex: 9999,
//         padding: '20px'
//     },
//     modal: {
//         backgroundColor: 'white',
//         borderRadius: '12px',
//         width: '90%',
//         maxWidth: '700px',
//         maxHeight: '50vh',
//         display: 'flex',
//         flexDirection: 'column',
//         boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
//         overflow: 'hidden'
//     },
//     header: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '10px 18px',
//         borderBottom: '1px solid #e0e0e0',
//         backgroundColor: '#f8f9fa',
//         boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//         borderTopLeftRadius: '12px',
//         borderTopRightRadius: '12px'
//     },
//     title: {
//         margin: 0,
//         fontSize: '16px',
//         fontWeight: '600',
//         color: '#333'
//     },
//     closeButton: {
//         background: 'none',
//         border: 'none',
//         fontSize: '20px',
//         cursor: 'pointer',
//         color: '#666',
//         padding: '0',
//         width: '32px',
//         height: '32px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         borderRadius: '4px',
//         transition: 'all 0.2s'
//     },
//     body: {
//         padding: '25px',
//         overflowY: 'auto',
//         flex: 1,
//         backgroundColor: '#f8f9fa',
//         border: '2px solid #e0e0e0',
//         margin: '15px',
//         borderRadius: '8px'
//     },
//     setSelectionContainer: {},
//     sectionTitle: {
//         margin: '0 0 15px 0',
//         fontSize: '14px',
//         fontWeight: '600',
//         color: '#333'
//     },
//     radioGroup: {
//         display: 'flex',
//         gap: '15px',
//         flexWrap: 'wrap',
//     },
//     radioLabel: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         cursor: 'pointer',
//         fontSize: '14px',
//         padding: '10px 16px',
//         borderRadius: '6px',
//         transition: 'all 0.2s',
//         fontWeight: '500',
//         minWidth: '70px',
//         justifyContent: 'center'
//     },
//     radio: {
//         cursor: 'pointer',
//         width: '18px',
//         height: '18px',
//         accentColor: '#4CAF50'
//     },
//     radioText: {
//         userSelect: 'none'
//     },
//     optionsContainer: {
//         borderRadius: '8px',
//         marginTop: '10px'
//     },
//     checkboxGroup: {
//         display: 'flex',
//         flexWrap: 'wrap',
//         gap: '15px'
//     },
//     checkboxLabel: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         cursor: 'pointer',
//         fontSize: '14px',
//         padding: '8px 12px',
//         borderRadius: '4px',
//         transition: 'all 0.2s'
//     },
//     checkbox: {
//         cursor: 'pointer',
//         width: '18px',
//         height: '18px',
//         accentColor: '#c2c2c2ff'
//     },
//     footer: {
//         display: 'flex',
//         justifyContent: 'flex-end',
//         marginRight: '15px',
//         marginBottom: "10px"
//     },
//     printButton: {
//         padding: '12px 30px',
//         fontSize: '14px',
//         backgroundColor: '#ffffffff',
//         color: '#0b0b0bb9',
//         border: '1px solid black',
//         cursor: 'pointer',
//         borderRadius: '6px',
//         fontWeight: '600',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         boxShadow: '0 4px 4px rgba(46, 45, 45, 0.3)',
//         transition: 'all 0.2s',
//     },
//     printIcon: {
//         fontSize: '16px',
//         color: "#595959c4"
//     },
//     spinner: {
//         fontSize: '16px'
//     }
// };

// export default TestPrintModal;

import React, { useState, useEffect, useRef } from "react";
import katex from "katex";
import "katex/dist/katex.min.css";
import he from "he";
import { FULL_API_BASE_URL } from "../../Config/Config";

const TestPrintModal = ({
  isOpen,
  onClose,
  testScheduleId,
  selectedSet = "A",
}) => {
  const [questionData, setQuestionData] = useState(null);
  const [quesPaperInfo, setQuesPaperInfo] = useState(null);
  const [status, setStatus] = useState("Ready");
  const [isLoading, setIsLoading] = useState(false);

  const shouldAutoPrint = useRef(false);

  const [printOptions, setPrintOptions] = useState({
    selectedSet: selectedSet,
    coverPage: true,
    twinColumn: true,
    watermark: true,
    roughWork: false,
  });

  useEffect(() => {
    setPrintOptions((prev) => ({ ...prev, selectedSet }));
  }, [selectedSet]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    if (shouldAutoPrint.current && questionData && quesPaperInfo) {
      shouldAutoPrint.current = false;
      setTimeout(() => {
        handlePrint();
      }, 100);
    }
  }, [questionData, quesPaperInfo]);

  const renderToHTML = (text) => {
    if (!text) return "";

    const decoded = he.decode(text);

    const imagePlaceholders = [];
    let processedText = decoded.replace(/(imgsrc=[^ ]+)/g, (match) => {
      const placeholder = `__IMAGE_${imagePlaceholders.length}__`;
      imagePlaceholders.push(match);
      return placeholder;
    });

    processedText = processedText.replace(
      /\\\[([\s\S]*?)\\\]|\\\(([\s\S]*?)\\\)/g,
      (match, displayMath, inlineMath) => {
        const math = displayMath || inlineMath;
        const isDisplay = !!displayMath;

        try {
          return katex.renderToString(math, {
            throwOnError: false,
            displayMode: isDisplay,
          });
        } catch (e) {
          console.warn("KaTeX error:", e, "Math:", math);
          return `<span style="color: red;">[LaTeX Error]</span>`;
        }
      }
    );

    processedText = processedText.replace(
      /__IMAGE_(\d+)__/g,
      (match, index) => {
        const imgSrc = imagePlaceholders[parseInt(index)];
        const url = imgSrc.replace("imgsrc=", "");
        return `<img src="${url}" alt="image" loading="eager" fetchpriority="high" style="width: auto; height: auto; min-width: 50px; min-height: 50px; max-width: 90%; vertical-align: middle; margin: 3px; object-fit: contain;" />`;
      }
    );

    return processedText;
  };

  const getOptionLabel = (index, pattern) => {
    if (pattern === 1) return `${index + 1}.`;
    if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
    if (pattern === 3) {
      const roman = [
        "i",
        "ii",
        "iii",
        "iv",
        "v",
        "vi",
        "vii",
        "viii",
        "ix",
        "x",
      ];
      return roman[index] || `${index + 1}.`;
    }
    return `${index + 1}.`;
  };

  const fetchQuestionData = async () => {
    try {
      setStatus("Fetching data...");
      setIsLoading(true);

      const accessToken = localStorage.getItem("other") || "";

      let setParams = "";
      if (printOptions.selectedSet === "All") {
        setParams = "set_names=A&set_names=B&set_names=C&set_names=D";
      } else {
        setParams = `set_names=${printOptions.selectedSet}`;
      }

      const url = `${FULL_API_BASE_URL}/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`;

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setQuestionData(data.sets || []);
      setQuesPaperInfo(data.ques_paper_info || null);

      const totalQuestions =
        data.sets[0]?.subjects?.reduce(
          (sum, subj) =>
            sum + subj.sections.reduce((s, sec) => s + sec.questions.length, 0),
          0
        ) || 0;

      setStatus(`Data fetched successfully! Questions: ${totalQuestions}`);
      setIsLoading(false);

      return { success: true };
    } catch (error) {
      console.error("Error fetching data:", error);
      setStatus(`Error: ${error.message}`);
      setIsLoading(false);
      shouldAutoPrint.current = false;
      alert(`Failed to fetch data: ${error.message}`);
      return { success: false };
    }
  };

  // ✅ FIXED: Cover page fits on exactly one page
  // const generateCoverPageHTML = (setName) => {
  //     console.log('🔍 Checking cover page...');

  //     if (!quesPaperInfo || !quesPaperInfo.paper_cover) {
  //         console.warn('❌ No paper_cover found');
  //         return '';
  //     }

  //     console.log('✅ Cover page HTML found');

  //     // Replace placeholders with actual values
  //     let coverHTML = quesPaperInfo.paper_cover
  //         .replace(/#set_name#/gi, setName)
  //         .replace(/#total_pages#/gi, '10'); // You can calculate actual pages if needed

  //     console.log('✅ Cover page generated for set:', setName);

  //     // Wrap with page break and force single page
  //     return `
  //     <div style="
  //         page-break-after: always;
  //         page-break-inside: avoid;
  //         display: block;
  //         width: 100%;
  //         height: 100vh;
  //         max-height: 100vh;
  //         overflow: hidden;
  //         box-sizing: border-box;
  //     ">
  //         ${coverHTML}
  //     </div>
  // `;
  // };

  const generateCoverPageHTML = (setName = "A") => {
    console.log("🔍 Generating cover page...");

    // ✅ ALWAYS generate a cover page (even without paper_cover)
    const safeQuesPaperInfo = quesPaperInfo || {
      header: {},
      option_naming_pattern: 1,
    };
    const safeQuestionData = questionData || [];

    const testName = safeQuesPaperInfo.header?.test_name || "Practice Test";
    const date =
      safeQuesPaperInfo.header?.date || new Date().toLocaleDateString("en-IN");
    const subjects =
      Array.from(
        new Set(safeQuestionData[0]?.subjects?.map((s) => s.subject_name) || [])
      ).join(", ") || "Mathematics, Science";

    const totalQuestions =
      safeQuestionData[0]?.subjects?.reduce(
        (sum, subj) =>
          sum +
          (subj.sections?.reduce(
            (s, sec) => s + (sec.questions?.length || 0),
            0
          ) || 0),
        0
      ) || 50;

    const fallbackCover = `
    <div style="
        page-break-after: always; 
        page-break-inside: avoid;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100vh;
        max-height: 100vh;
        overflow: hidden;
        box-sizing: border-box;
        background: white;
        border: 1px solid #000;
        font-family: 'Times New Roman', serif;
        padding: 40px;
        text-align: center;
        gap: 20px;
        position: relative;
    ">
        <!-- WATERMARK LOGO - Top Right Corner -->
        ${
          printOptions.watermark
            ? `
        <div style="position: absolute; z-index: 5; margin-bottom: 10px">
            <img src="data:image/png;base64,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" alt="Logo" style="
                width: 300px;
                height: 240px;
                object-fit: contain;
                opacity: 0.85;
            " />
        </div>
        `
            : ""
        }
        
        <!-- MAIN TITLE -->
        <div style="border-bottom: 1px solid #ccc; padding-bottom: 15px; width: 640px;">
            <h1 style="
                font-size: 24pt; 
                font-weight: bold; 
                color: #000; 
                margin: 0;
                letter-spacing: 3px;
                text-transform: uppercase;
            ">
                QUESTION PAPER
            </h1>
        
        </div>

        <!-- MAIN INFO TABLE -->
        <div style="width: 100%; max-width: 650px;">
            <table style="width: 100%; border-collapse: collapse; font-size: 14pt; line-height: 1.5;">
                <tr>
                    <td style="border: 1px solid #000; padding: 15px; width: 35%; font-weight: bold;">SET</td>
                    <td style="border: 1px solid #000; padding: 15px; width: 65%; text-align: center; font-size: 28pt; font-weight: bold;">
                        ${setName}
                    </td>
                </tr>
                <tr>
                    <td style="border: 1px solid #000; padding: 15px; width: 35%; font-weight: bold;">TEST NAME</td>
                    <td style="border: 1px solid #000; padding: 15px; text-align: center; font-weight: 650;">
                        ${testName}
                    </td>
                </tr>
                <tr>
                    <td style="border: 1px solid #000; padding: 15px; width: 35%; font-weight: bold;">DATE</td>
                    <td style="border: 1px solid #000; padding: 15px; text-align: center;">
                        ${new Date().toLocaleDateString("en-IN", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                    </td>
                </tr>
            </table>
        </div>

        <!-- STATS TABLE -->
        <div style="width: 100%; max-width: 650px; font-size: 13pt;">
            <table style="width: 100%; border-collapse: collapse;">
                <tr>
                    <td style="border: 1px solid #000; padding: 12px; width: 50%; font-weight: bold;">SUBJECTS</td>
                    <td style="border: 1px solid #000; padding: 12px; text-align: center;">
                        ${subjects}
                    </td>
                </tr>
                <tr>
                    <td style="border: 1px solid #000; padding: 12px; width: 50%; font-weight: bold;">TOTAL QUESTIONS</td>
                    <td style="border: 1px solid #000; padding: 12px; text-align: center; font-weight: bold; font-size: 16pt;">
                        ${totalQuestions}
                    </td>
                </tr>
                <tr>
                    <td style="border: 1px solid #000; padding: 12px; width: 50%; font-weight: bold;">TIME DURATION</td>
                    <td style="border: 1px solid #000; padding: 12px; text-align: center; font-weight: 600;">
                        3 Hours 00 Minutes
                    </td>
                </tr>
            </table>
        </div>

        <!-- FOOTER -->
        <div style="width: 100%; padding-top: 20px; font-size: 11pt; color: #666; border-top: 1px solid #ccc;">
            <em>Strictly Confidential - For Student Use Only</em>
        </div>
    </div>`;

    // If paper_cover exists, use it - otherwise use fallback
    if (quesPaperInfo?.paper_cover && quesPaperInfo.paper_cover.trim()) {
      console.log("✅ Using server-provided cover page");
      let coverHTML = quesPaperInfo.paper_cover
        .replace(/#set_name#/gi, setName)
        .replace(/#total_pages#/gi, "10");

      return `
        <div style="
            page-break-after: always; 
            page-break-inside: avoid;
            display: block; 
            width: 100%;
            height: 100vh;
            max-height: 100vh;
            overflow: hidden;
            box-sizing: border-box;
        ">
            ${coverHTML}
        </div>`;
    }

    console.log("✅ Using fallback cover page");
    return fallbackCover;
  };

  const generateRoughWorkHTML = () => {
    return `
      <div class="rough-work-page">
        <h2 class="rough-work-title">ROUGH WORK</h2>
        <div class="rough-work-lines"></div>
      </div>
      <div class="rough-work-page">
        <h2 class="rough-work-title">ROUGH WORK</h2>
        <div class="rough-work-lines"></div>
      </div>
    `;
  };

  const generateSingleColumnPrintHTML = () => {
    if (!questionData || questionData.length === 0 || !quesPaperInfo) {
      return "<p>No data available to print</p>";
    }

    console.log("📄 Generating single column print HTML...");

    let html = "";

    // ✅ Declare set variable here
    const set = questionData[0];

    // ✅ Add cover page only if checkbox is checked
    if (printOptions.coverPage) {
      const coverPage = generateCoverPageHTML(set.set_name);
      console.log("Cover page HTML length:", coverPage.length);
      html += coverPage;
    }

    html += '<div class="print-container single-column">';
    let questionCounter = 0;

    set.subjects.forEach((subject, subjectIndex) => {
      if (subjectIndex > 0) {
        html += `<div class="subject-divider"></div>`;
      }

      subject.sections.forEach((section) => {
        html += `<p class="section-heading">${subject.subject_name} - Set ${set.set_name} - Section ${section.section_name}</p>`;

        if (section.section_instruction?.trim()) {
          html += `<p class="section-instruction"><strong>Instruction:</strong> ${renderToHTML(
            section.section_instruction
          )}</p>`;
        }

        const questions = [...section.questions].sort(
          (a, b) => a.set_ques_position - b.set_ques_position
        );

        questions.forEach((question) => {
          questionCounter++;

          html += `
            <div class="question-block">
              <p class="question-text"><strong>${questionCounter}.</strong> ${renderToHTML(
            question.ques_text
          )}</p>
              <div class="options">
          `;

          const options = [...question.options].sort(
            (a, b) => a.set_option_position - b.set_option_position
          );

          options.forEach((option, idx) => {
            html += `
              <p class="option-text">
                <span>${getOptionLabel(
                  idx,
                  quesPaperInfo.option_naming_pattern
                )}</span> 
                ${renderToHTML(option.option_text)}
              </p>
            `;
          });

          html += `
              </div>
            </div>
          `;
        });
      });
    });

    html += "</div>";

    if (printOptions.roughWork) {
      html += generateRoughWorkHTML();
    }

    return html;
  };

  const generateTwinColumnPrintHTML = () => {
    if (!questionData || questionData.length === 0 || !quesPaperInfo) {
      return "<p>No data available to print</p>";
    }

    let html = "";

    // ✅ Declare set variable here
    const set = questionData[0];

    // ✅ Add cover page only if checkbox is checked
    if (printOptions.coverPage) {
      html += generateCoverPageHTML(set.set_name);
    }

    html += '<div class="print-container twin-column">';
    let questionCounter = 0;

    set.subjects.forEach((subject, subjectIndex) => {
      if (subjectIndex > 0) {
        html += `<div class="subject-divider"></div>`;
      }

      subject.sections.forEach((section) => {
        html += `<div class="section-header-wrapper">`;
        html += `<p class="section-heading">${subject.subject_name} - Set ${set.set_name} - Section ${section.section_name}</p>`;

        if (section.section_instruction?.trim()) {
          html += `<p class="section-instruction"><strong>Instruction:</strong> ${renderToHTML(
            section.section_instruction
          )}</p>`;
        }
        html += `</div>`;

        html += `<div class="columned-content">`;

        const questions = [...section.questions].sort(
          (a, b) => a.set_ques_position - b.set_ques_position
        );

        questions.forEach((question) => {
          questionCounter++;

          html += `<p class="question-text"><strong>${questionCounter}.</strong> ${renderToHTML(
            question.ques_text
          )}</p>`;

          const options = [...question.options].sort(
            (a, b) => a.set_option_position - b.set_option_position
          );

          options.forEach((option, idx) => {
            html += `
            <p class="option-text">
              <span>${getOptionLabel(
                idx,
                quesPaperInfo.option_naming_pattern
              )}</span> 
              ${renderToHTML(option.option_text)}
            </p>
          `;
          });

          html += `<div class="question-spacer"></div>`;
        });

        html += `</div>`;
      });
    });

    html += "</div>";

    if (printOptions.roughWork) {
      html += generateRoughWorkHTML();
    }

    return html;
  };

  const configureBrowserHeader = () => {
    if (questionData && quesPaperInfo) {
      const rawDate = quesPaperInfo.header?.date || "23 December, 2025";
      const date =
        rawDate.split(",").slice(0, 2).join(",").trim() ||
        rawDate.split(" ").slice(0, 3).join(" ");
      const testName = quesPaperInfo.header?.test_name || "Test";
      const subjects =
        questionData[0]?.subjects?.map((s) => s.subject_name).join(" | ") ||
        "Subject";

      document.title = `${date}                    ${testName}                    ${subjects}`;
    }
  };

  const preloadImages = (html) => {
    return new Promise((resolve) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const images = tempDiv.getElementsByTagName("img");
      const imageUrls = Array.from(images).map((img) => img.src);

      if (imageUrls.length === 0) {
        resolve();
        return;
      }

      let loadedCount = 0;
      const totalImages = imageUrls.length;

      imageUrls.forEach((url) => {
        const img = new Image();
        img.onload = img.onerror = () => {
          loadedCount++;
          if (loadedCount === totalImages) {
            resolve();
          }
        };
        img.src = url;
      });

      setTimeout(() => {
        console.warn(`Only ${loadedCount}/${totalImages} images loaded`);
        resolve();
      }, 10000);
    });
  };

  const handlePrint = async () => {
    if (!questionData || !quesPaperInfo) {
      console.warn("Print attempted but data not ready");
      return;
    }

    setStatus("Preparing print... Loading images...");
    configureBrowserHeader();

    // const printContent = printOptions.twinColumn
    //     ? generateTwinColumnPrintHTML()
    //     : generateSingleColumnPrintHTML();

    const printContent =
      printOptions.selectedSet === "All"
        ? generateAllPrintHTML(printOptions.twinColumn)
        : printOptions.twinColumn
        ? generateTwinColumnPrintHTML()
        : generateSingleColumnPrintHTML();

    await preloadImages(printContent);
    setStatus("Images loaded. Opening print dialog...");

    const printWindow = document.createElement("div");
    printWindow.id = "printSectionDynamic";
    printWindow.innerHTML = printContent;

    const existingPrint = document.getElementById("printSectionDynamic");
    if (existingPrint) {
      document.body.removeChild(existingPrint);
    }

    document.body.appendChild(printWindow);

    setTimeout(() => {
      window.print();
      setIsLoading(false);
      setTimeout(() => {
        const element = document.getElementById("printSectionDynamic");
        if (element) {
          document.body.removeChild(element);
        }
      }, 1000);
    }, 300);
  };

  const generateAllCoverPageHTML = () => {
    const header = quesPaperInfo?.header || {};
    const date = header.date || new Date().toLocaleDateString("en-IN");
    const testName = header.test_name || "Practice Test";

    return `
    <div style="
      page-break-after: always;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: 'Times New Roman', serif;
      text-align: center;
    ">
      <h1 style="font-size: 28pt; margin-bottom: 30px;">
        QUESTION PAPER
      </h1>

      <table style="border-collapse: collapse; font-size: 16pt;">
        <tr>
          <td style="border: 1px solid #000; padding: 15px;">SET</td>
          <td style="border: 1px solid #000; padding: 15px; font-size: 26pt; font-weight: bold;">
            ALL
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid #000; padding: 15px;">TEST NAME</td>
          <td style="border: 1px solid #000; padding: 15px;">
            ${testName}
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid #000; padding: 15px;">DATE</td>
          <td style="border: 1px solid #000; padding: 15px;">
            ${date}
          </td>
        </tr>
      </table>

      <p style="margin-top: 40px; font-size: 14pt;">
        This document contains all sets (A, B, C & D)
      </p>
    </div>
  `;
  };

  const generateSingleColumnForSingleSet = (set) => {
    let html = '<div class="print-container single-column">';
    let questionCounter = 0;

    set.subjects.forEach((subject, subjectIndex) => {
      if (subjectIndex > 0) {
        html += `<div class="subject-divider"></div>`;
      }

      subject.sections.forEach((section) => {
        html += `<p class="section-heading">${subject.subject_name} - Set ${set.set_name} - Section ${section.section_name}</p>`;

        if (section.section_instruction?.trim()) {
          html += `<p class="section-instruction"><strong>Instruction:</strong> ${renderToHTML(
            section.section_instruction
          )}</p>`;
        }

        const questions = [...section.questions].sort(
          (a, b) => a.set_ques_position - b.set_ques_position
        );

        questions.forEach((question) => {
          questionCounter++;

          html += `
                    <div class="question-block">
                        <p class="question-text"><strong>${questionCounter}.</strong> ${renderToHTML(
            question.ques_text
          )}</p>
                        <div class="options">
                `;

          const options = [...question.options].sort(
            (a, b) => a.set_option_position - b.set_option_position
          );

          options.forEach((option, idx) => {
            html += `
                        <p class="option-text">
                            <span>${getOptionLabel(
                              idx,
                              quesPaperInfo.option_naming_pattern
                            )}</span>
                            ${renderToHTML(option.option_text)}
                        </p>
                    `;
          });

          html += `</div></div>`;
        });
      });
    });

    html += "</div>";
    return html;
  };

  const generateTwinColumnForSingleSet = (set) => {
    let html = '<div class="print-container twin-column">';
    let questionCounter = 0;

    set.subjects.forEach((subject, subjectIndex) => {
      if (subjectIndex > 0) {
        html += `<div class="subject-divider"></div>`;
      }

      subject.sections.forEach((section) => {
        html += `<div class="section-header-wrapper">`;
        html += `<p class="section-heading">${subject.subject_name} - Set ${set.set_name} - Section ${section.section_name}</p>`;

        if (section.section_instruction?.trim()) {
          html += `<p class="section-instruction"><strong>Instruction:</strong> ${renderToHTML(
            section.section_instruction
          )}</p>`;
        }

        html += `</div>`;
        html += `<div class="columned-content">`;

        const questions = [...section.questions].sort(
          (a, b) => a.set_ques_position - b.set_ques_position
        );

        questions.forEach((question) => {
          questionCounter++;

          html += `<p class="question-text"><strong>${questionCounter}.</strong> ${renderToHTML(
            question.ques_text
          )}</p>`;

          const options = [...question.options].sort(
            (a, b) => a.set_option_position - b.set_option_position
          );

          options.forEach((option, idx) => {
            html += `
                        <p class="option-text">
                            <span>${getOptionLabel(
                              idx,
                              quesPaperInfo.option_naming_pattern
                            )}</span>
                            ${renderToHTML(option.option_text)}
                        </p>
                    `;
          });

          html += `<div class="question-spacer"></div>`;
        });

        html += `</div>`;
      });
    });

    html += "</div>";
    return html;
  };
  const generateAllPrintHTML = (isTwinColumn) => {
    if (!questionData || questionData.length === 0 || !quesPaperInfo) {
      return "<p>No data available</p>";
    }

    let html = "";

    if (printOptions.coverPage) {
      html += generateAllCoverPageHTML();
    }

    questionData.forEach((set, index) => {
      // html += isTwinColumn
      //     ? generateTwinColumnForSingleSet(set)
      //     : generateSingleColumnForSingleSet(set);
      html += `
                    <div class="all-set-wrapper">
                    ${
                      isTwinColumn
                        ? generateTwinColumnForSingleSet(set)
                        : generateSingleColumnForSingleSet(set)
                    }
                    </div>
            `;

      if (index < questionData.length - 1) {
        html += `<div style="page-break-after: always;"></div>`;
      }
    });

    return html;
  };

  const fetchAndPrint = async () => {
    if (!testScheduleId) {
      alert("Test Schedule ID is required");
      return;
    }

    shouldAutoPrint.current = true;
    await fetchQuestionData();
  };

  if (!isOpen) return null;

  return (
    <>
      <div style={styles.overlay} onClick={onClose}>
        <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
          <div style={styles.header}>
            <h2 style={styles.title}>Question Paper Print Preview</h2>
            <button style={styles.closeButton} onClick={onClose}>
              ✕
            </button>
          </div>

          <div style={styles.body}>
            <div style={styles.setSelectionContainer}>
              <h3 style={styles.sectionTitle}>Select Set</h3>
              <div style={styles.radioGroup}>
                {["A", "B", "C", "D", "All"].map((set) => (
                  <label key={set} style={styles.radioLabel}>
                    <input
                      type="radio"
                      name="set"
                      value={set}
                      checked={printOptions.selectedSet === set}
                      onChange={(e) =>
                        setPrintOptions({
                          ...printOptions,
                          selectedSet: e.target.value,
                        })
                      }
                      style={styles.radio}
                      disabled={isLoading}
                    />
                    <span style={styles.radioText}>{set}</span>
                  </label>
                ))}
              </div>
            </div>

            <div style={styles.optionsContainer}>
              <h3 style={styles.sectionTitle}>Print Options</h3>

              <div style={styles.checkboxGroup}>
                <label style={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={printOptions.coverPage}
                    onChange={(e) =>
                      setPrintOptions({
                        ...printOptions,
                        coverPage: e.target.checked,
                      })
                    }
                    style={styles.checkbox}
                    disabled={isLoading}
                  />
                  Cover Page
                </label>

                <label style={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={printOptions.twinColumn}
                    onChange={(e) =>
                      setPrintOptions({
                        ...printOptions,
                        twinColumn: e.target.checked,
                      })
                    }
                    style={styles.checkbox}
                    disabled={isLoading}
                  />
                  Twin Column
                </label>

                <label style={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={printOptions.watermark}
                    onChange={(e) =>
                      setPrintOptions({
                        ...printOptions,
                        watermark: e.target.checked,
                      })
                    }
                    style={styles.checkbox}
                    disabled={isLoading}
                  />
                  Watermark
                </label>

                {/* <label style={styles.checkboxLabel}>
                                    <input
                                        type="checkbox"
                                        checked={printOptions.roughWork}
                                        onChange={(e) => setPrintOptions({ ...printOptions, roughWork: e.target.checked })}
                                        style={styles.checkbox}
                                        disabled={isLoading}
                                    />
                                    Rough Work Pages
                                </label> */}
              </div>
            </div>
          </div>

          <div style={styles.footer}>
            <button
              onClick={fetchAndPrint}
              style={{
                ...styles.printButton,
                opacity: isLoading ? 0.6 : 1,
                cursor: isLoading ? "not-allowed" : "pointer",
              }}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span style={styles.spinner}>⏳</span> LOADING...
                </>
              ) : (
                <>
                  <span style={styles.printIcon}>🖨️</span> PRINT
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      <style>{`
@media print {
  body * { visibility: hidden !important; }
  #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
  #printSectionDynamic { 
    position: absolute !important; 
    left: 0; 
    top: 0; 
    width: 100%; 
  }
  
  /* ✅ Force cover page to fit on one page */
  #printSectionDynamic > div:first-child {
    page-break-after: always !important;
    page-break-inside: avoid !important;
    height: 100vh !important;
    max-height: 100vh !important;
    overflow: hidden !important;
    position: relative !important;
    z-index: 10 !important;
  }
  
  #printSectionDynamic > div:first-child .page {
    transform: scale(0.95);
    transform-origin: top center;
    margin: 0 auto !important;
    position: relative !important;
    z-index: 10 !important;
  }
  
  #printSectionDynamic > div:first-child * {
    position: relative !important;
    z-index: 10 !important;
  }

  ${
    printOptions.watermark
      ? `
  /* ✅ Watermark only on question pages, not cover page */
  #printSectionDynamic .print-container::before {
    content: "";
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    height: 300px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcIAAAGLCAYAAAEjSKJ3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAgAElEQVR4nOy9C5hlVXUuOqqrH9IPoQOCoElohJOcAM0jQUALpb0XSzrxSoOg3xHDw2v0ajVISAhqDLbnisiJEZqK18eRR8QcA2I3n0mT0nMFpK5CMEB3oydJk25QARsxgN009qOq7vevvcausecec825nnutvef/fRu69l577bnmnGOO9xhDMzMzpGFkdOx0Ijpd/bCeuGdyYvwebWQdDzkyOnYAET3XoAez4frJifEP8Wdz+B8jo2N42ufu+8cb6jTY1IjHf2n8PBGihxwZHTue4gtOe8vqhjyODoz/H++4NvqMH5RX8uF+eEDGW865guSOjGhSLm3R4B+7+IOfpi3//tOOu/NnH/nEl+i+720qawgXDb3+zR98hIiOK/KuGPyLL74UzWj7l84/ky4+f2X779vW3U03fOEb7b/xGa4pcjfx7pyLBzxh+VH08KYtuW+6ePF+dNfXr20PVG6ZG2/d0PEAxx97ZMfn+AzXXPL+cwjjuegD1+QeD6Ow7SppmgefZlXM7xRxRhz1mldHJNJmIXlYBw9o0aL92v9OO0D+Dr7/kcvPb/87K27/mzXRA05OjA/NkT+S5wExMBzdeWcf3z/zjJPb9836oDt3vtT+d/SQeFrKsJqgHV5BDKyoQ4Pvc/stazI9KK4HTfNzzRGfrcINX3nIr3nf7FNXvTf6v7aC+CG8bvrclYn3OO11y9vXdrwvxpJl60u0H3JyYnw9xbPnAwyKma686YaTH6INpzzU/vvII14VXaNNHt6/+i/e2/7707/zb9H3P/2f/609WH5439Xk63gVyVjJ6APf7XHXtx9o//uG/3Zp+zsz+4hm9nZfj8lrM//Lz1d/49afHBp9/5iFOztW95UH/5rXamJn4Tr5gF0PyTj3gqsSb4YtdvVnbm2vInge8LaDniHCAyoPycADgn41bN6xpOv7uD9OSvJYTZwRGroeErPws+3/kXhDucUkTl30fLQS//PZA63ftT0gI9oJ+xIvUcHkY64i2VaSiO7NclIePX8Hzeydof/5vP/hZQLfx0sD5F8bksarPuTkxHhkEbCtJrYztmiXKIhtto9o864lmR8S3ze3O58TpoDP0A4bCdtKJh5C2M44bC65Ym3H+7ZDJw3w/TTbFYK9dth4PSTjplvv8v7BpK1W1j2gubiQ+JCYHWgG2mpiq/Kp2h7gvni7ZUSkiqU4ePh0T1pF50MyTKLmrYr/d2Bva7utf/kP6BfvONVbUsF1uP7/+OYnWtvd2PKYTMmXbeOywfmQmlxrriDjwNu+T2f98veiF7bcukUP0rPnnEJvOfMD1ofD57gO17/rlydE38V9JDCZzJcZrsNGYq7PTOBG0DnxY6v/9Hp1sOaPU0zPj//t39Ct8x6iZ992Ch105/3tz/D3uvlEP98zn/54wSl01x3X0j/Gn5359is6tAgTQhlY6jN+r4dkmAIzthAsARiU9YHPP5N+9sx/0PCFK+nnv38KveIf7qcnfv/1tHCG6M+WraIb//rP6C7PrcfXQGrCb09OjD/vM26rBV0DVlPqefL/SYCGjofh61bPbKPzJv6eHtn8mLozJGy/57NNGV4HjwQPtD3gP73eKVOCifMAXzv9XPSA+Nv1gFIj4oMniySW6iHNQwj/x2qQh0zKA/zMt271HijIgydHHjxpVpGyrCQRLWMThdw+oBNYCFzwfUC+L6tPbIXA76cdcCqaZEjaBKD9w9yQxUrXde9Tl7cfDCZOPmWz0CIj00OS8qCm4SnLg8rvYqcwHeZ5QMr7kNogTdsrBgp6sgHmEbYDuWyuWR+S8JBZX69/8wdnpqenZ/B/fj208d863rvuc7dHf9te904+0r72y3/zD13347/zjDPzSlJrNT9ORFdJ2mGwmcNn29q2OE5XqHVEtMLmRfZBrockhTZdDyLh8508tMjI/ZCU4kHToKgHpIx8UoVpJcgLKQ/nRSEPidmGEl1UvAHuAxovYhWpyJUkoieK2K44xOL7XFTEoKjIh5ycGD+ccroAAahu8f1uLmZkxa5k28LH0RdpUeRhI1HoQzK2bH0y0/dc7omsKPwhsQo+OqYJXA/GX/QqUlkrSdl9in5+w5Qo5SHTeq6FMvzxMsZT2kr6+jrLOmwkSntIRtKDClHwhTLHUIjsmoSR0TGYDfcnY/sKmr2oSJ6oofSHZIyMjl2HEE3x1iqOUygbSZHLpRwCZcF2aJlRy9UsaclQoz7wcLBwNzliGWNH8IRcqHbQIGRMGa7ZZEhWhPhWnGQX9MWTKcAWvaCsbcnBRV2O2diDrIWWFfnblNZFl+bmZtinFiMHl7z83OV/TAOOaSj0AeWDIWgJ0VnygSSgAEPTNz8vyujFITaFPSAP7NyzTo9CqKEWJQ1UGqLg32C7Db7DvpM8WHvtJdG9cMjMCANtJsBILN1meYJ/5fc5dDrrvaIHZDaRdWtIT9W5f3hV5BLPi7zbVLIJZvQvZPUs8cPh+0U8HGWMXZWQ25/DrQ9IezPpetPSJ3xZAF/HUc0M0++fZlzSBiujkIdknKgLMrSMLeFRBPLJD3X9oDZA830cNNr34YlOs7viay/jv7uUXx8+hIFxWBnPMF4cc6oFyWoBQyb4+xzRLM2UvruBWot1nfqAWEXp2k6NOOzr4nevVL/p3Lbx92/8yoauj2Taku3emilE5YOuLcGrZoaYcOCeLazMBf7+wz+apWnfWB9bwK4aWk0JW0JKJxyaQjFNRiGY+7KrlPhuUghnkp2HM3HMz2wGqKWYsfNWrej6wBY3ft/3NzmD453Ymy0ENF5dNWLJFlIdxZmtft/Z3j+CGcwbbTyzN/33xcHyIe3zTOHU9gEWu0VlfqQGHxur00aahgfNKAHtqWBsUUnvGpDt6oIzjJocPKgjjSjeYogW9o0wxjX//Pb/Lbqet+ib5j0bfYZYHBsilvO9TYWEUF/GYVqkrOjKM06J/o8ffNlN34mig5/ZMy/abhxdrAYHfX9TO7L4N2dejLYmvvtP772O1nzzf6gDkWHU8T3vdQ3ey/hrahs4XZEzbPInyJMQueQg1s1/MPr3qj0ndahD6xY8SDTT+b4x+Ag46JYsXtgRdZXGv+Ft3c4SbCsf6BtzHqSzp0+KtvTnfj4R/Zs/TzJV5A24TaXRs7TADwUl2QyblpBmCGyvO2B8epro7Dknpdb5eHumyR+hqkKmGTBlrP38Ha1kTY9c/yLCpdM+oFojoOjoKMc9n+DIDx+kDZVu1+ugOOWWlJIQeXGfSAQzNfs0D5f6AckIJ+EH4yoNRTwkWwhA71InzOoVzmw2/G5MQ5I28kQPm+Gbcot+N0dtjsLCo6GFQ1HF7GOgGDB5hltSfCJzHI0ZgVyb0GhzcORhajCvtUzIC2wYS4u8EcNWe+p9SgUVDUmRxUVEZBQSLQwR7cNr7JI9l36RcAW9w7oHQ3LecJNCfBO2VHMGLHDSk+SDPK4EiVqGQhcZLFTYA+a+iYLaxHlnrbSiQUgstQt/XsGJWVkBXlp0HFuRoc9R4gccj1mRpgSNLwoP58p64DQq5DlLnkTR6hajlHBnmB/S+vSowINFoqzY0VvSaPllBsiWFeZ8IXmyjUNLOFgkSo0Z5QNHs5pBPj3huKMiF1yZ4c25kix9Xpws+dTPnm0nWn73/5tNrCz796uM+u34oVJXTcD5gCOjYzDybKtiMAEqbuEzzQZ1EWXQPMXuiDT+0IBigNgq6P0SGnVbQ9NhkUwbihNQDjSDrFzM9iLyAkKx46DLgHrBXExeyI66xNCuEbHUxAWE4vypq/4o0ccvUXLp7tJgEhmnUaCs4t3UkKr2fMwDt6+/J/Kv5gWXuGLUfQ6wTnB8s+l5Li9gHvtYmeBF45phpvfDTFjIAtxTq63CJbrqtqjwy2FschERYfPGImrZFwUpVMlF0xYMUb2PZUz2Z2jmCFs6Tx0W9NL3n9PxdwdPjHIiLriqMI9PWmi+RjnB0jtcJiAXyEQzuXDcdEFrlVHlPHXwRFM6xQVVM30OkmJfqXT/Y6KSaiuXDZwIsnaJSZ1FJtP5wJBbonAiVU/09b4XMSASE8N5bVRT4UKeCjw+3nBlj9dsuyKrFHRZbHgh0xReywJbPAo2DjaQDWXyJqTaRSUBheSngccg+XGZrMhU/Uyrjc3s1n6z7GhDmPM4h8P8nd894Jf0z8+/vOu7GtKeHFEDBUueiFk9d+m8vXTEopc6xiLTfGXklmYqywPznk6zm0RZC2mGq1EssKy+4vquXbzhJJGRN0R03o9e3y4ClgTbgpr6YBI+/56307te9XQUfs5Y+eCJ6vOQsZA+JZR9YFK3zSuS6MXgOpdUEBOXCwg9B7oYVBukYpoU9oG3X0jXHBmrPfHQ7zj6z72q70ucFpeAZUEpzff+4YR4E8VTdMcxnb9vbkb5d5FzRQ63litN5uP8ZdwQVJB2MuSgZN4Ox5fYqkoeu3BnO30UqTObn1+cegHbv5txzJy2w+Ow8UmWqpnKea6ywljANYV0U5AL+Ya431MWsNriEk5wHP2XpU8RIXMtfm3asTjzpGTGvpmOMdjAOSA4riXMTHQXIJmbOqBPOTfvwAxeSPAa7fhLAq5F/pYvEC7epsL49bfPHlbY2vhCUqGrFwnzQI5+w0LI1C+fOVoptIHS2gvwjcHH0uaUcqA0P2QS48f920dZhmTZopBmDJzmncUGjXkEYbAwVnpngfgHniBHbUAb+CFlbrsKHGXy1Qs4xlCE04CPT7ZdZ4nLyRTnFidXRcodL2TRXpAOKsjRmikr8DxSsNIo0VYOwxeGAHNL1sCqzMGKiICWAg+OyaT6yMz0Td5hQwc/2kv0ySX/2vYsJOWj5AGsL/wbr/7XyU7pdC/RsuFdHXfPWvKDK7YZAkxiMFQScufOcPcoDEhWkpHAec99hTTeoVHxWc//Hn124Y/o8DmtiTt6aAetX/KD1of3/4B+ce5fR//8812/RY9OLckkMfM4+b5Lo3+LC7B48Sn6sZd+i7ZNLbTey5S4bSeTLcQiDwpJgOKFBJXBUGsupOmrhAUCeiL3YXl6+y+ixeWdbVsQSLgsIH31ZQ/RQpqi/zr/X6K/n13Vqnqw6qXu5H4JjOutc7fTxfN+TOti1yQflat+dVL0f8048P8o90rqnKDFKd0Xt0ZilaSouNRCA2uTTHXsKbdZOXygLQ6b2N4051kaG54Njz17b+diRkUP5j3Y/nsXDdP5e09UUwgp9p77GrPNZ4G+B49MUhJpkYHFZSTRtEufap4KacwtwiNhUg3utYx20Wfoh9HfP7j8evrvn/kyfZ42tRaOTux0NOc0WGvPoD23+PtebhdbFEoLcZe+SRnQZDqAi3YtsdsGQgpcRXfs+yf6p6Gl9Nf7L2+bwoo05pv3kwvGnhLx+VLfJohpUHqmCVkMxNrfMBgX2VEnS4USH0hvP9/XZBdm8HWZeRlV1NGPfsD0gCueam/HcC/BY4QxnOvlaJtSOpbLTqypJGMoSeAxJ0A225OSXK+hnRZmS1bt+arIjKoy7aujs4UmfidFuvUi5kb+vgzF0E4R6n6uVDWR8qCyRaTWQp5FROsoISbFJuiY6kUZi2pWVpdHJiUkGSkUecLkxPgjhQ/QgkoXkSEFniQR37agrzz416zFnBHiCElYM7BDakU8j63oJKoJmqV88Tv4PbyPz03w51UIMDb0ZBFJLCRHmLkoS+ZguK6NFO3XLe8wfcFqhJereB8vis/vsJ+UrUi9WEDq5SKSWEhTPPcFbwAJV7ihLd4mS4UPGUfTqwWkXi8iVRAeWQaMcWauvVYUSm8q50K8g6OyuVmczFVCMe6v6PUCUh0okTEyOobJeI4UZbkOMHl3L49PE7VZRIbNVNdLYCxsi6WaLSDVcRFJLCS7iXq5kHUSYGyo5SJSTQSeXpjQsqDngo0NcsJ6IfAYC3hZXReQ6kyJjJHRMQQQ3UQVJXVyv4c6CjA21H4RGVLgKSrryIRphG/CAlKTFpHEQpr2yiKABZR5+E1ZQGraIpJYSM2XlxVNEWBsaNwikiK5UkZ9UvFhVtbQvkg0chEZcjHZUUtxJLfWVDjBydxz+2ceNHoRJbLU/2/asWlD6kWMU8ADysPNkxPjjxe2gGbx2oBq4TopvKpmBPQeqSpmmItXZ79eP0OxSHVJzNYKUiTbUoi4kYBqwMVoqVty7ijkbq33XVUtt4BkcO6GETS9glsatfMQzcWrU5T1IAPlYaS3Jl6Tu7kUU+RuilPOInCmUli8egGLKCPxmODYXxjlC3Ih1iLqZgcUD8QVmQIlirS3u8s0JRxQgy2bV0NZbqoqYK7RXF48s1RV3cF1ViV8It8g3cGhK3dyk4Q1pkJeRFBg24FqyyGoC2TVeyowuk1Gh7va+NYBcgE7qmHUdfFkKH1SgQMsAooY2MqJ2JJnpAcjCuk44+TGUGUh5UzKRJLvL21NUrAJWTGfYjFdluOUmbtm7YA6orYLyAuXlItoAtlLqLSYVP9Nlp2mWFHm+0Gw4e/KhTTLktQJtVxA32TRLL0uwOdlHqGs4s/UKRNEMQYseB3TA8gUYnotXvORaDb+qCLL1+d36pIaoEqh5gdVQ0sUldRBFU5c0kL2ehG5bAoLWHNMP1PepldZoC1eVIA1XjxIx1VO2GmW/k5E3TVzqgaynIV0fEtH6D38T3mKhmcBlGpt8eSEmbnvVaFui2j+HtxKc0h4e9l5aIraZQFivQxxNwdZB8lPVvGtwyLKmm6kJb/ggqyFU9NCK7qjDLTnQPlKs26cHCPssGWDLWUMLsg3R7zR5oWwQpS9s8wB1XXxGFrxP4rHmqWvRhqwzVdYypbyP0wKvJOEhFMWuE4MD0jy3aTFY+vIJUajxiKA45zvbwMWkdUbeR02Ypkb3uzcJqspdizg5MT4WfzvtL0p0kAmq0CqYsnXl/KgXrgm2xd8H98eT7LXIm883ohlbCxFcOnQGrQE0Ig8mXEXfb5zLVKGWQ6S8b7D/Tp4Zl3INN874+BOU56s4ijfw8YqA2JuNpq371pASZ5lne/MS5JUlrcd8gxtOPmh9ssF3wUxfYE2bDhl9rcvW9YdKG1WNWbYyohlAZvvGJMT48ebt1FTsE0yLeooNQeUeHROi1eKEOOkseIz73Y808bLAOrEMWRpL/53XrBLTNhel2q3TMqhb3eFKRI8IJ5oqWNJKpqZFq+pdAPAPUyLUtpNiN+UY9DGyHNjUl0RbMesrm8rA21dQFk3UwumSQvb0WJtETAVv5gSUkIez5nGzr/L4/BEEWzHbNiSuY8hKJkE1eRp6SMlTy9mn3ECJXJJqo4NxHNRhkXGqG36RNK1rkaU7eKnp8XtfIqATxftjiM0AwXmAWJvXL/v2sxp+xcyOAqA4aog7KwjY5JvUj8mGzJ18nQIEWXi0EMOdP7+Ccd1L6Csh5qmd2H7nvGmECEcy1zf8S0E9AIPjAeZBjAFsQLsLaVNzcy+pqvNdIsmcnqmYwzHLtzRcY20F8sWBnmgCC7ORE/fNrDtPHJkKmU579kExcKMlssu0csjFNQV/e7M7O8fu98Oj29mRxrBRSJNKa6LSHQB5WbKWcHV5MnGT6YNQaZCgLoe3bmkQ4hZNJR+EGmCpQ3B5QXf76Xp4dtOgIHjVwbY5oW6gFO944HA1t37dWygI+amL/11sac6YZoX01TOyNS/lx2/3PAjLzRqZgWeX0V3JXVh577h2d+fJjp6/g53u1oB6M4+ggw/u4gGPyHNODNXMwS5m8XKNfhM/KGvPLD7TUMKrHoBH/3Vkq4xPLxxi/V6sxej+bcNZqH4tH0rsjZfjgB7YBEKrBkBcOyCHS0pULw0sb1MbN69pGsMPouSJprBtE5V1niZiKLg0Tx9/ZJwzLwdHccnjrC8QlMWmMc4OpoWCaOIn7fgIpG1c/aH+N+IjE6iwiwPfczcHR2eiEd3LynMyp8KxhHq0zXUl09yIDUja8mvPF2zI3Lnh7JZW3xbpTKgXhw9vKOl+8USIBawJ4glYR9d1OTRSTybTxMRBb/CerEDheRGcBJ+EXl1O198iZbGKtdMzBHeseAp+r/+4EJ6dF9rIcsK9ZCJNH97wMOdi5bSGASPhK3OAAQX2UCTK05kQa4F5C7ZJCLZ8voPIen9urLb/+9F/9r+91+fdQ597VeHddRSyQqucAhF/asvf3i2qNhMfv1z7Re609JY9SqqWn4RRdGjAFPfSDbe4TZpDZLeWb/8PVr70uGzR9dMJy9657ynoj7zV237H9GGSWo7bh3HM//RCtr94/dF9/rq4oe7eB7//nf2HBiNKS20ut8+jcLSIPcRigBTpkIcoTYqBLVgcVjoQfS3dp2kKJnyffLwc3Tlgpjpiz27btGDtOuxh+i0t2zxPlrxu2+dt53WLfpx9Ld5VN697yBau6flCOBKwecm3I8N/K5C7YrgkrvkZVH5gYjXeA5nPhcfkOc/rBJaA375uebFRjImXgzmUcvm7KK/mt9qY47FXEhTtG6/B6P784Rr4LRpXBuBFw6LNnUQrd3bWjQYls91eF20yDrma5rKwyEeQnBZlfgDniis6KurmYd8zydFy8Xf+Lvr5j84++ZQvBD7lnVRI/O6dQse7BBIzt9zIr1Iwx19B024EjvN59FSs8vqFFNYhq4UaMiRa4iJBDNPugbHrfzMzIc3U7C/Ma+1MKcPPUuHz93VkWkFysNv4ho+Ls/ee1LHfSTSJLraFl0uHicLldHmp+gUa1gT9tc6sWBSeMGkK8kXOLL42JKLyV6RyNlMU/SVOQ/R4bSLXvviT6KF43y6bww/GOl1P6Ql9LHp37ZSaFqwOUwL9mVAYCsr36PQ1jzSmoAjRE6SuaNZGs3ilsJCakmYd9zxGTp7+qSIt43NbIsWDtd8g1qLh8++dcp5HeMCpUaRZBkWTx3b16/t0Ifvi3sNM4qu1V1Gb6XIqsBHiOnUlPVeqADHsFxIUBsm7Gw6KToq75h+kFbMPBv9G+9Fxoa/eG/H9/K0+LHxcj4pmBqFzfiizD9mQeELKK0KeDApEeJvWR4LNVqoIMuKXEjc75w5J0UehLGprdG/+TegMxZxnGm+PlNNADXKKhrSKV4USuluZh4TptuE/5YFdnx8iz7A4rCb65y5r41eklJ8/XQucNiguRmYVbDgwqyirDYHpbenM/MFtL+pQO8+xUcWouCwcFBHIMwU3XuJjNJkeE9uyDIFF4nSFlDuOJZA258ZkW1FHqUMRMFhEaFLFpmwKkP2OcOYqVE+R5mCi0TZFBidlXysMFPnyDY+ZuTOLXoRi6QCbAYto8os1ECdgktx0V8KSl3AyYnxdpcXs4QJF1PQJqRXNViSAOnVzIfgscqsXfNvOQdloHQemFTCRFtURp0WEWNEUTxSxgj+ykHLrCJV2Zew0h67ZgkTLCp7MOQ1jDososw11MYm+StUpKorbFSygEklTNhEZi6irAZRdfUoiqVI18bSqJFRVXe0KinQWsIEVGhSIvgIXwsKwGdVFSBifyUpddqSPCni2UoVXCQq7SHI3gp2FZmTwM0cTfcN3pNG4rKakiRVKSShHpjhlFHtmivWto0EVfYmrHoBYex+jkTBA83PZtvlGk/My3NgTDftseY9uZqiWceU4mRVWdG36saSlXfx9PUZwssN47RWSd+kSAlsiNvW3dPBjxhm/VET2lhczmfzGfp+AcnoFU8e5bUooVp9XkkVx6G0mpj3lUejdk2v+9H3qmY2Evd/U3P8msA1stGxeeyai4+jDuK8LGxOngXR5e/49o+QxVedF5eAnjVCZirERCNwyZeXyQWHCY7tj3kg75lEceY4eiW4SPSyaj1CwLaBv2EBOezQBV5oLfoM1AUqs90H30HSpenLS9sbggv59HrxqNetyH0FGh9Akvzon7zbqSuCZ8GYnscv2GvBRaLnveSlQNOEdjem4NXrfvSV2kItyFXCpBcQ1Hdnr8fS8wWUkWymTbRuMDOwZIHcXqEOFEgcrcWT04tsXBdYLREmPLX8Y9XoOQ9kMC9kXaxuhc/rJLhI1IUCSythUgRcdat7idosoIRvCZMqYTbcqAtqtYBllDDJi/ssDTfqgjpSYKklTNIgqeFGXVAbIUaCBRpuetwrgaaugotELXmgbwmTMlFnwUWilgsoYSbEVP3bMboabtQFtV3AqptxSfg03KgL6k6BqUqYFAGl4YazbnUvUUshRoIFGkRGI7y9bIGmCYKLRO15IIvu7Hk3QyWKRNa61b1E7RfQbMYl68YUjTQNN+qCJlBgac24zHumabhRFzRiAWO0Hb9FI0vDjbqgMQsoHb9FNOOSyNJwoy5oEgUSlzBhEb8IBb+JgotEoxbQLGGS18SGDZC14UZdUHs9UINp7JZF5HzBVRWbpPNpaOoCwrT1MP/tk2MhoV3fxMWjpi4gJSwiWULuEU3NNUlR5oQrZVCDF4+avIAMGd1NwuSmQctwavLiUT8sILUWETXILkj5tWVNUhds6IsFlDAp0sATTbGw+KLQBRwZHUOk8nXI/St74AEBPcQtkxPjFxb185mJcGR0DBF2d3tcGhAwCLg3a9RpKiIcGR0Dl7vUdR1cr+euOr03fccCAkoCrAg33npXV8EZC5ZKj3YSvIgwSUaXpg4JJK4jtLmIagQBAb0EjO8rzziFzlt1upqNbKuFE8MpuiYSoY34UG5YVn3wra8SENBPQF7r129Z00GYCQR5veyCK6ES4cjoGPyobzTfN8t+BsILCJiFpA9bgU3Nl9JFhBr34wKMSTcPCAhogWtvUlwpXokfuWxyYvw6lQg1AmTqbkJppYCAOoFpx9Kksq0rtokwiQC1aroBvQFHl8NYcOghB3aMgQv7Pb39F0mGgoAK4WBiF6HTXUSEI6NjjxDRcYEAqwfis2Bh7lXJHKgWa79wR64emQHJYFoyAyUp1hGZCDu4IOuAQQQtDty8QANKHqEOcbYKFt8AACAASURBVJW6Njhp5M+1jAlrv/qKtb4+sQAHEkLTnxh6/Zs/2BV0mTaWPaATZlN8RlMsyiBQ9CYygy20tjYBfmDGps3hXJMAWecI8Af3i5KwKONWwJqGqvtlFnpgQHdEBxyIRxqgT5obhZ9RmuEDUfoDGeKYPy2KrJftJRoNM2DBd0PiO9xbuVcAQdkOWxu3BuFKyUgjSkfkyEAjqRtGFxEW1VK/H2HqdbZGewxwt5s/d6V3uXfcS1ZzKwtR073zV7Y7CEtAlDarFGjjMokSvjHkVTOy5Ff3M5IqP0AnRCjNZ+WbPn3aBgWy/Rl56HVo/oSGTkmAhcwmCvYaXGggCRCzk1rGBZG1Gzwn2v5RraPcQo4G2DhjbkafppYacIjhMGsq0HyMG0hrSOLepoFqULmj7Myn7KPrmQjhub9JfjKokTIyRO+xrU/SRR+4Rr0uqfWvrRNsPwCHs814lMQhza70g+T64GfXnrvtJ6RWxIzVYU8DwBEl8dlETnxuaySEg0rrt93PQAob90CVALcD19MwSMQoVRkt5pqDuc3Y0cfN0hS3/82atlm1HwlR5kPaiM+mJ4Vg9lnYJIOkxv2ua5oMKYprYrjMptCyKLqy5+VG7acJc4ncNuILQQx22LijNmdcqZL6zIADHZobeWvPbaYz2fIJu+rHyAlrutVUip7aKWUzRgTi84ctakibQ9d6NAkuDu+VTyiRlFnR1KReF/fTLJ1ZiQ+iPCIlml7iA/5RPEOWg1eTJpAQINtyMnjukwxidQaP38LVrYWgnDVm+iXHUIaWaZxcs/rl1fmSXBd1y06BPvepq/6oLUaZcAUmuKDpjNrhJhNimyJ5SAOMZZ6ilCXb9zMXemrSZMlIF22sRXI/131twIH29guuqkwUs4mLNqSNhdWgWZe1wAXJPeu+t2SpcEvYnrPqmnfJQ63ujEsBrQNcYzQJxSd0bMMpDxmzOET/8+e/Rl/9yaG0ffd8673TQMs9ywMz8icL5Pyd+msv0Lte/TQdseglIrGHvvrTQ6NXEsx5gZsC7goJeUg0dW/51uZPW3e0K8TNZYrtJZImCW4X6GwSvr6+Da99KPHzlf90YvT/otp95SHIIluOYQ7/+Ign6H8/6BfWazbvWEx/9r/+k/NeWnifuUZShagbIbokwTTNMVJX4B4ZHUMfgG3yPZdTshdIcqtoBMjXmEHaIEqk/dz3/U1tx/I//F4yEf7+D05U05uKgM9mlGGHRf/2uw57mv7LYU8nXofnp1hUW3nGyR3ZJiSeQTPamM9XR47oMMCk7pWRuqUdOqiYVA7uJyc2KdawCsCdYiNAnF42AqQ4zs+8Hvfi2L8I045XiXmZ2AA27oa5x2dl9i7etGOx1/PjEISuZBKgBA5s0zhlisw40FlnLKOdb1rwGKCyKAS4Jkuzmsx9JTV2y5sZImAvJ4z9mWiOZsJsBGoSqc06yDh28Q6iKbK/4k141GvKrRmD+eVngSSCv4tolOrC5h1LWs+YNAeOlDh5QMFKLK/Fs5gGIymK28IGywbGLGNAFQsoWnx9PMswcjV3jQmxoyEqNjUHL/eCEHljQow0/XPmeLLoWccu2kkz06S/ZlrvU7SZFuZ5DC+AS+OZ8hpc0qL9rDP6PAA7E3RrU0ows0xwmJgZ6HxYwsJqC5wvCzgUpG6qBWHn6bGXu8Ny3Hv8Fvke2DR37K+SELE4rCyb/kuzoBFMyVly+pbvt8Muhk0RPfrLxdF1Lo7aRLSJR3I9iziaFJitJTmbEompMkTvxXuqykMHh3qSu6SI7qSFtDmPi5h2eLoRKcJmZxCiK9G1CPDiaMQFg4sEfDppwFbTY14GcXRm9jXd+dr04uLSn7NXaBPhdPdzd8yJA4e+8kD1AlPEM8VS7ClGFbWQsG9xqGPttSppRbUHLoQIqUWI95iDwmnIg4dhQwvsLQOmmGkaKrJYb7dsfTL6f5f4NdX52vzikkqesRc44bjWxjefOXqJOTl24Y7E0SVF5UhoOi5zwzIszxIyPFOJCstkgLGhMCJkJBlsYGXUxIwikFQ8SQtHS4uHN8bGA4dlcPOu/iXCthjpmINjX5ZMhEkwraUmIUpuWAYgscnyLspeOSGrAcaGwomQHIQIhbsMPZFN4XmCypNEnLYFz8M8369gY8mju5Y4iHBn5hkwA7uTQuuKLg8JlUWWoTAtvLEB5pFCf7QsIqRZQtwo38ODcfmDsgw2pqhpNjBNCkL2IUJVFBMiGVkMD/2ETbsWW8VxvI6e1+KEj8UifNHgPYRu0EUBElpSfHFR+p+G0oiQWgM/HvKzfA9BwMytQIhlm5tNPRTRLzawzpMI7fSfiV8xEZqNWvoNj/5qSeezWySCJDdFHrDrqah27NiHuJfFAPNCmQRIZRMhtQgR8vMy+R64FdcggUVTq3+ZBmksZUmxoU5H/QKLe8JwVPd7FfPNIEIPN0Vbj1aQdPiaYqBJbEXWpZHNWhQDzC2xC65UlE6E5BHqhvCmXoe6+eCYeTtoZmpm9jXd/SJfjtpwaM8u54YcUTNHHeHvsipDvMc9pQFGCdxY4eo1XxQqIUKGK9TNDCmrGxbh2LdxwKlYTOtTRz1DddhrHDFF6JoLSYWGswAqCoc2QiKzGGDsekvBqJQIKSHUDWIih2GlRdJim0mWefoALhvelWgV3Lan/FC1XqMtRua0EidJCy4CzSPuwwAjg/uTqqBVhcqJkGZD3e6U70EeZ8tmkZbTDd++v+PvLPonn8RHD++wx41OE22faiX0YnHxYsdy04FYYATD45nYKJI0D3hFB1YC8kgLTMBpra9sgCHdAlq6AcaGnnVlmpwYP2tkdOwsIlrH73EuInf7ydLlB74j6fBFFIa0kOLfaZuutA0MU5YL4qV7z8t+Er3a+NoP6OZbDqEvv/TrHZf79HvoFcz6OwfP2U0fWfTvdPnwLrpcmigkt1Mi1UCE26bKkQyYgNPU6HH0j78T+7HIMaZBT1ujTU6Mrx8ZHVtKRM/xe9ztB5MGud23wFBkcT3j5ChELUsBJW9HvYkhfRMy3jpve/SS2PXFh+mcz/4OPTO9IHpXlpOsEuaGfOeCp+iqBU8RvVwZhEvENObgsKHdmZ6E67Uwkura+IQfeiScr6hS/9OQOrO+LCRVdfMtDGvrMAwnrAzghkhl5hrKTHwT+P27vvVAJNpqnHnZnF30zvlP0muHRT2foXSSzcde+i16dKpl2ElqrZ0XUrq45GXbaMVce6kKFWK//N3ew+hre3QdG4faeatOT0zq9an5Y14j+0K6Mu1lhQFL6RVnEaYqUBsiJAchksekJ4kcrsWV9WiyQitjePDQbvrw/Mfo8DlCR3LQ5937DqK1e1quVbMZaRZIwlu38EH3HcQq/P2+Q+jLe3+j42Nw7kvff07ucZlrYIrpiBM19WpeR5eqIgsKVx0Bkxa1IkKy9MNwTaiEjRtqHXJ9apYgoBcbIw9nwqHw4TVf7DiJL5m7jVYMP9t5obItrtl7JD0wtTR1tTRZQPeLCzbSK4b2dF9kLP3H9v42PTo9G4CetiyiNgaIf77qQVFcMEsV7F6idkRILUJElE2H/CnFxaSqbkkEaxag1U7aLAChot98Gs4AERdEws9xzNAO+sTcf7Fe/wQtpMv2Hh39O8l6LIlv3fwHyba8P5+ZT+/bN9uEKwvB5S0ILOEiQEo4YLVrLFW8rVWwe4laEiFZqrr59sPghdDEQ3Oxy+4lCJfIRy8/v53xb4NZ/PfKOVvotUOxuiLO7btnDqIbppZ1FJ1t/1a8Ob8x1xA54yW+fPpo2jbTslgm6cASVbQ7wJrKqJgkMdQ2HikpWKqbJ1bB7iVqS4SMJD3RVo9TLojGNX1O3bLhclPIjXTl0BZ6LXXaD86eOan9LGy40q57/8xyeoZaVlhZK1MDjFVV982AO0paprXOxq72fB61b2thgLGh9kRIGfthuOpVmoTY6yafsqWyCdlM846ZFpcDc/w7Ooz+bqglen8jfh8T9TgtpMuHWqKrFM8liihrnxcmAcLQYpYdcbUwKKoKdi/RCCKkFiHiJNtfvueqguzqq2gSYlK756qh6WhSz7ljqkV0tw0dRufNPBX9+56hg+iGOctUI07dmveY+rnGAdOsX1MJkJpEhGTph+GymKUlRG0z9BqmM5+JEQHlf7P3n2kXDdO75/1u1/PUtcWYT/8P3yY+Fh/yxjiXtRFoFBFSixCRXnKTfE+WnNf8Ry6dwbdtVx0gDxX5rE1oa65xd00NcD2LrIKtWGcvm5wYv67osZeJxhEhtQjxABnqRh494lyfa2276twIlZ8HzwKirHuvSN/2c0kipuuwjatgZy7C2ys0kggZSQYbmyjm0iM0roj7lFUvJS/gqqhzJ2Ct+5I2n1Lk1g5Jl9rRFP1PQ6OJkDKGukl9w+Zv1E7uXltQmwTNBWPTt10GtiLbkNURjSdCsoS6+ehILmLVRFSqOWfsNTTOBx2cawpJSB3RJvo7XFGp25DVEX1BhNQiRCjjHYVqXJZRMvxzNr3KRox1tKT2AuBSWmkSrQMvKV2DXYckomeUor9rii7C2yv0DRFSixAhY3bEK/mGuknxKcm0b4vb1Hqv9zvMcDOGLSbXl/ikAUYGKgg00gBjQ18RISNJT3RZPCUxJlkczRxFCZ++902FZrhi+Egb5HChuPyDTdf/NPQlEVLGUDcJs911Uv4aEkeTSrKXHSReJlwxrknGKjNH0+W/7HcDjA19S4RkIUTXQmuQIqiLgLHpXDVUtcz+OsBn7DY9j2FyPYs+1z0nyQfkC1UU4e0V+poIyRLq5gr6tcHkjj5lN9Lk6YHTQpTN0rrNF7AYo4eDbzMVLajahEl4aQMHHKrC9ZMT4x/K/sT1R98TIbUIEYv4WfmezMdLShK2wSRIshsRupCkT/YSGPtH1nzJS3Q2xdQsETseRrMTyuiCVDcMBBGSR6ibpRKXN7RcvSRrrA0gUHCpsjo7QRRGnmLabBFNN8yTWe9yH/Wr/qdhYIiQkWSwKSrHDsQNv6LZyATcAq6MtIRZNWzV3ooqZ+EKpBgkAqRBJEIqoKpbFoCzQRe1tfPCAQAOVUUcKA6J885aEZUktGXa+xpU0sIxz31tgLFhIImQLEnCvUoHgvgJY0lR/fZ8geAC9GusijM7JI5bquqCVDcMLBFSixBR+OcC+Z5PqFtAOkgDjKWOTc+rYPcSA02EZAl1kyZ3X4tngA5XqcpB0/80DDwRMpL0xLL0o35Hk6pg9xKBCAWK6IcR0DlvFAjQiZ70J6wrkjoJw2hSZN/EfoY0wCgEeG8gwE4EIjQQb5CN8l1sJHZuB0K0A64Pnh8EPygW0FV1LEPfawRx1AKtH4ZHpeeBRdOrYPcSgQgToPXDKDLUrV/QD1Wwe4lAhB6oItStqQgGmPwIOqEHkgw24ABafZVBgLQcBwNMdgQi9ES8oV6QV2PjISgb8ZeDZLCRBhgEdSuum8uCAcYfQRxNiZHRsfVE9Db5LZnm0++hbjIP01LyIxhgUiIQYQaMjI6dhUa48pseJdobj2CAKQeBCDNCSxImd7OSxmJQizBVgUCEOTEIoW6O5+mLKti9RCDCAtCLJOGq4ODsfVMFu5cIRFgQtH4YriyCOqNf25DVEYEIC4QW6oaseRQHpgaFurmsvUH/KxaBCAuGFurmkVleGwQDTPUIRFgSkvRE1HZB1bW6YRDakNURIWKmJCSFuqHjbN1C3WQVbIUA1wQCLA+BE5YMV1W3XuuJUv+zGGAGogp2LxGIsAJoVd18e/WVBZn/ZythH/S/ahCIsEJoeqJJjGVH2kjDS0L/iI2TE+PHVzo5A4xAhBVjZHQMm/th7VfNfn5UQMlFWXLQ556B+1WPQIQ9gi32lAG3xs2fu9Japj4NXN2JA+frLQIR1gBaVoYLiGiRyFDKfiD7PtQRgQhrCC3ypgAgIfn4EGpWPwQibBjisv14QXyUnAy9HEBg9wRCaxZKJcI4hOvweNMEBDQR95TdrKZQIhwZHbuOiC4t7IYBAfXDE0T0ocmJ8fVFjSw3EWqO6ICAAUEhenZmIhwZHQOLfmPYbQEBETL3WExNhEHkDAhIROpqc95E6HIuM+BkvvT950SZAgEB/QKE+N14611027q7fZ7o+smJ8Q/5ProXEbqcyYh/vOHaS9ulHAIC+h0eMb7ewRBOIkwyvID4vn7LGjW0CoPc8O37+7L+ZsBgAdFJ5606XZXuXCGBPrG4iUSYRIBasHHdSzcEBBQBmYPJuOSKtdbQQRchWonQZoAxU2+ojytOBwQkwcxQeWzrk3TRB65Rv5FEiCoRxqFRXRroUa95Nd3413/W/vuGL3zDV1ENCOhbyBxNSkjQthGijQi73pSZ2Ek/FBAwiJClLRPo416tW1UXEWoEaHLAQIABAd3wpJOumj0d1dZGRsdU30YgwIAAN1CtAFULGCjopaCrqoJZ8vCz5gX90lMhIKAKgBDZZYGKehBTTcRehzbaRGh+AFzy/nPa/0ZpvoCAADfgO4SlFJB6okCH22+O7QPg3LNaOiRu2oQeCgEBdYF0VWhiqWR6c+M3LjQvgjOe4SgSFFAR4KM96ohXRz9m1ph5evsv2r7aDPVmAkoAHPjobAWxFGtnMDIwvYju5sZv3GQOgaNhAgFWC/SEX3nGyYUHwEM8QjTTfd/flKuEYoA/5GGINnlmg1VUnkAu4lztjlIXhCgaUA5wOiLqgsX+MoHgerxkhAc67974lQ1hjUsEQjmv/ov3ttseGEB2/vFzNVFU6oIBxQKcDoecZVEiIG1mw7cfiDhXXtESqWVveN1x0e+asb4YAwIwOAjDoz5pQErIWGoEvBg0dRz+M/T6N3+wq8MsuyWCS6IYgBCgY9sIDwuDtJgq429BlODCtvSzQJDFIaljM0LZQIQdETJYHLBP7QsB6QCOp4maEAOv/stba2VA0crltz/LWYp/0CFbjys0taJLJ9SciwHpIE8+BkTM1Vesre1mBifmJFXz8OCIKXDGoKKkh+OwvbCLE8pmkUEcSQfZd5Bx+/p7aO3n78h0P+hwkExwkiIuMS2w+HhBL2HncRrAcIQDxXymsjtH9SOYrhSpYqNqHQVCfqA/ikhwhksC2dum/y8PcC+8IGpKIP0M9VLAnZMAvxab1T911XvbbhOIrXiFJO70gH3AIMLjrEQYHL5uaHpUUoa1BPLPPnr5+RGnqxpQOVjtAKGt/cIdTjGTe+zLrHK2HfS623CTgGAL8+CyEmGAHVp1AV99SSuN0EvgWaSbAsQ2+X07d8Nz4iX1XszFI5sfo9V/en3YNRlgJUIsTkA3pFgGYMMyl7ABoqoMA/QFiHrDt+6PNngWgEhYp/QVc/F8FPu3IG7agNhIeRjhGaH3hFIn6WE1zATluxMa93OJYRBVTX3MBoiwiF7JSnBpAMunjIpKAgjqwg9ck6g/mlnlPgfToIHpSlNXuoiQxYykojWDBrO0h+uA8iU+GEhQp6eXgOXz6qve67S+4rBxpbP51loZRCQEwNzbJY5CDOE4w4Bun18S9/MRO11iXtVA4ABngyeNH5IANpKZPS7xlnOu6DBW4frg6Heqduu7OCGFsLU2ZFUBl2QAUTVpspvm6EaER5IeCd8nfKAaTNF90FUbaYzTwtaQ1Gs1adXJilc1JAFiE9kIEKc+rrURICyGmPimRZpAd8G4be4W6JRyjiQgKeC7rEdijiBRDCqYjmx7IKq2ZlZYSwo47XeYp3iSOGXbhNSHIV4IXbPpjUlcUe6lQbQzyP2k0RJzwi6svuL6jpsMCkwChP6nESCb4zVA52si53MBhxF0Pg3giqblmAGi47kAMcJ4M0hwSAAXkagxc4v8RBoe0PBlEGASIAhJM8BAvrcZL7BJ62R0KRoQLzEvmn7HhhutORCkArYC4/NBIkSOu9XisCcnxqM6M3PiP7oTey9oxQxi0rIEDzcJGgFqwDWanoyTXupA/Q7oyLY5AoFplnW4Y3gjDgohymdUJKON/A8pjj4hr4CTljeVLP7bj/AhQJvxBQHOg5ptgrnSArghgtkOK0mI/WysAeNiqQBGLhOTE+PH81ttIpycGD/cvFDqAL6RH02DT3Fjm/6H6+FnG2RA/NZiRmU8qgQIUeqI2jX9AGZcYGSKhbmD4ZmGmXvNqzmY15Z13WRIccEWDaIRIIw1g+5DlUConWa0MSONGOCGHJ6Ha/rNFSZDArV5MRneHOPDrloMMgbQUlu/kYAoxOICLH+aEUYjQJzitoiRQQYbbUzYCBHck9UdfN5PVnhHobQusUFzUVxkvsEWP1h6kJTYdGBjsPEA/i3NDaERoDQuBOiwEaLG7SSXsLk4mgYpXVksol1Nl7qIkM2mElL5vr0PXBZ8MkOf00pPaAQozewBydAIEXNuVh8g49qmW0xdxhgUO9DeVJ31RLTUfEPqTE0uBiUJzKyITJZDRhoTAvygESL8q5ofkTcsPmvy3nIYY14w+xIyVCKcnBh/3rTgQGdiZdrSaab24IRVshhi8FymuA0pIIsIiuDnftB1kBSc1ZWgEaLG7bBhHV2Mag/pPbAYYw6wPYONE6ouC2mKzpIp3kuAGDgjHnqgaYiBjmiewrgmTwRMVHH569dG3BdGraYEPWBDYcx4oY5MnrQ2bUNq+p+MKW2iWMreA0tpkMS6H1YijNElm7FeBPm+Sae8XHhND9RO+zw9Gc25gVEL4go2Nn6rbnOHA4MJr0h3FEQzM2gbz65xPBml1SS3hfQaaBUFNGOMRCIRTk6Mf9x8DxZCRlMsWpLDaYSlPUdePyC3MNMAzsIcstebDRINxlGm0xyipqlTY01M/RBRWiyWNsWJD/WF40MtxhinkuvihMAy8w0+sSjWGeoOPnWh05piKERUkytVWTUMmy3KQK84IgmnN35Xs1iWAejV5txrYqfkmk1QediQl2CM0XO8BJxEiP5puJl8DycWh2tx7cm6QhpjNOKSn1McDZNUbOmwl+2mM17xH9H/k3DCcemK+HJycNmckYkvqStUFhz98p30vmXJZSxsxjATCBAn0SOzrshjjJHw4YTqzaR539zIdQIbY3hhJbTAdFc0zIqD/oMue83j9N+P/yFtOOWh6HXziT+MCLMIMGcsOiiCM+GLIL5DFuyh9x3+U9pw6sPtOfhvv/Nv9LZDnnF+19SZNJeETJWqc5SWwxhzi/amBi8ijNHFRnhjF91VtihIccbMgdNStLzF0JnO18HzdtNlRzxOG05ubUgq4BSHmFOEOMZ5fkU1IsXz3XT8oy2Cm57pmgsXsGFNsVTTyVm/KppjFwUPY0xXeqAN3kSoWXjkxq6jWZkJQYt0Mccr/aBJeM1+u7o3nnhtfmFxoeNPql/jQlLGe1q0iz5N25/dhwhJEUvxfCaxSf2qbtxQGmMsLqxUEQdpOKF6cxbfwFmKbGaSF9K6Ji26ZDldfd0Ri4ancm3ALLAlEycBh0ypbbgzzgFLH2YeokZoMma5TpBRVUo+pZcxRiJVLwrcfGR0DEaa/fk9GDJgGQIRokxeXVJ8eNNqBYjMBZenrhk3Cu6IUvRsYp+Zab1UzBBtemFJCU/TOlRwyPlE7yQVoMoKEA/maWba7wbgFivPOIXOfPPJHUTEPSuijk7GOHGdzM+UGxzPX4fgeWmM0Q5uX2OMRFpOqP6ItAz5llcvE5JrmI557VS1+HciQCSUdWWOXbwztziWFXguVwhZGQQILGafXtKzzxAdMn9PdBm4BQwX5nwfJaJvTD1d44Zsd6iL856NMZq7i4juzHLP1ERo+zHmFKWKQJ6QWRImzE2cugWcQyfavnt+qc8GR7/NGl0WAXbAQYQHz0923UgHvWaxNh34klB77ZOWh4RmxJucGD8ry30zEaH2Y1JUqIsirdW4NI0cSVxQ4umf/aL110xMiNM6QZZNhBRbo02Jo2wCbPs9NeKT85ESZiTNzQqnr4NPumhjjERWTgisMt+QZuVeJf9Kg4wpLpihUGlaeLWvTdqAJYujEpA42MhRqWXa9tzxaznE9RQw9Txt39Sh72HRxhiJzEQ4OTG+3nyvw6zco+TfpJLjpl5hLq5XlkOSODZNtHlnOYYZDQg20GIwywC7e17cO1yIm0LCPAxNlUZ+3ot8Q1fscRZjjEQeTkiu5N9eVmjrOmEVg4ypMy5O2Mx8wLB1tOtVLSNso+r8u62/2m+W3pR5OHbRjtT3NA9DzbjXy3zDpNjjrMYYiVxEGCf/dlRok07vqiu0JVlmrzaMGabv0BsJXDCLTtQ4JOjDmTmhR9nID6/5Yk9mShryijTGSOTlhGqFNjnYKgu8shijxfKZoqYWRZMUbNAWtR3WwX7HpheXJFtH5+3JNAOmnpUkklYVFAIjHic0W3yUXXaRLMhNhDEuM9/gQeMhqk5gvdEwfReqM3kQYZ0ihwqHy0Uxt0WEadt+m/7cJKnm4ndXo+bIkD/NxqDZRbKgECKcnBi/rusBxKCrSP6VhG6WMLzUNOcrpdvJN/0IQcv80pSiPgd0QvW55bxkgI9IWmWKk8sYo9lDsqIoTkha8q8cfNkRD+edZbeamb+tlbfwhs09IVwU/dxA58WpYfuzC2kgS4ts0+hhGtOq7PbLxhgYhBRjzL2xPaQQFEaEcfJvV4W2qsoVyHAiF2yn7lGOgkbQd6zWUbxiw0ySlbXpABHiOZPmgRSC8oFJZOeuskdflemHlilkWsCHZgfJgyI5oVqhrepyBQi2zgqX7njI3N0DaYyR2Lp7YecbGebDpjObwfZJPkEEh5cBqDVJKXBFGWMkCiXCGF1eeinLl22kMRVoUxRNHStqwiNsK21pi8bB5aYoYp4tYMmqrDhSab/Q3FhFGWMkCidCrUKbFDOq7vxrEmGeStrH7rdj4F0UEXLOQR5Rko1qeWqh2iD3StnGGIkyOCFpNfdlTcmiTfhJ9zM/y1XO3rH5IqNFAwoU5YYH/JKTuwAAIABJREFUESZxwkMPOdD6mSuetywOS8JuUYUxRqIUIoxr7lsrtCH5t0hU5Zc7dsHORFFsm6kv9Rna8+whkmfFd7+3seOb5oFWFhFWbYyRKIsTOiu0FWktZR2s7J7xmjW0/RoMN2GEpOf3mYMkndn04VahX0tjjJbjqLULLBKlEWGMrrJvbAEr0m/IroUtsdJeFg4etlhHY06w+aXiijzVER3FngqMHZUwxdEqpBxpjNF8kVq7wCJRKhFqZd+ko7yoPDh2LTy8sRxRhX2PBw/vGXgXRReU+Th2QXImRZLObPpw0+j7WSCtrLKyvEApxhiJsjkhaRnHsh9do6JLErggXo/+qrpcwl6g7V7ycFE0BZytD+JXjEIbyzLGSJROhFrGMZRr1t+0KthZYSrtphk7SxQHyRCsAXdPtA9MxzwsGpqqZDx5o2akMUZrGDs5MX58rh/wRBWckDSWLiu0lZX8a4aPbdmaPp6RJPEmxqzN0IvTw0UMu/5wzMOyebsqeYQkV4cLHsaYrsygslAJEWrJvyTy/qpO/tWQpF/sjLm2zRrIr617+9tFwZt2656F1tjZmYpr7WSFhzGmKzOoLFTFCVU/i6zhX+fGH6o4qulFA4KI4yfMwzHz0pe4qBLywO2VMUaiMiKM0eVvkaXO88r45vfNjIokbuf12w7DzMBgph6GmazqBQeL9NIYI1EpEWr+FumczVuhLY+OkPTdxNIWA4hH9xhWYGNOjhiuRifMYmiThZN7aYyRqJoTkqtCWy9K2nnDJ4Oin0tbSCS4KRZSyzqatsSFhjS1YX2Q1K9SywCqApUTYczqu5J/ecGylLTj9JY8IU4+3+1KXh1Qrrh5T3exp6KqfJhupae3/8J6bdo4UhkcYjHGdGUAVYFecEI1+VdWaEub/MvWy9KzFzw2HjYGOlMhIOGxksPoqgJCDSGtyI5bPgdSlggmM3ijqIBtSCgcWWUxxnSVZ6kKqVqjFQyw/o7ZQCYzOCEn//rK/FjsvATo+v7Bc3Z3Gl+Guq9Zv/QH9LVfHUZfe+mwaPNwND6e5aOXn1/bjsYasBZmUuuy4V30zv2eopPnPW/n/DklAlOcLyoU0WGMeSIuz9IT9IQTkoX1y0VPU6EtzWmZq/yhy0UxQ/TOBU/R+gN+EL2uW/KjaOPiMIE7BpwETVXLzvbICuRaYox48Vq8dcH29vN8dsmP6OS5z9vnwXDXJImSNt35NOOgSmPhtkFm7FiMMV2SWZXoGRHG6BIBpKjgW8IgiQjNJN6VGbM35pPSn91BkIfP2UWfXfwjWr//D+hLSzZF3BQ+R0QLYaMXYbgoAqgRi/FwrdiI8Pb/QfR6z8t+4v28pjiaxajiKn+SpaxFUsPYXhljJHpKhFqFNpn8W0QrLLPwU9YUqgOG9voZYiyb8hVDe+iLizfT+pfHGzvWg7H5c2X75wD0Vv59xHt+afGm1vgWKISX9rkdyBq4z4eo7wEmjTFaqcteGWMkes0JVVFAigy2hpg2mC4Oc7GyLv6jU0vorB2/R5e9+Dv0nb0Hdie1ujoViddb522n9Ut+QJ9c+K/RvZkTVcUZESCB34MEcczwjmgsX138cHRQ+D6D+ezPTM+nL//q16M5woscEopWFtJUFTROytfYCjhLSGMM1AAFPTPGSPTSMCMB02iHSRR+HMSU+hozwD0RdQNOl7nZiwWw1uKeWPht0wtp7a+W0VqxfiCqd857khbK7IEhxXJj4Hfm7KB1i39AP5xaQn/+0m9FnBHiWBp9GITra5RCrC6HCkI0/sLCzdG/vV0K4kKM+Wt7XxUdTia4X31a0fFiI4Y4aR191piNMdDBlWLEPTXGSNSCCCcnxj80MjrWQYTw43BgN0QKmXWh4fZ190SWVZ8qXLgmjfsAm9zc6NjQt627Jzrtv7n3kOgFQKx7z7wf04q5z85e7KDHo+f8ktYtepD+bu9h9LWdr2oZcM5fWWhgO1wMbG3+6sKHWgeGD/HF1+yaGaYv7/0N+s6+g7ougfSBQr1a+zkbIr/srd33kTB1uDRhjdIYo+2dXhtjJOrCCSlO/u043iBCIN+QK7QliTc4GW2OfugCssEIFsginngDHFpyaXAk/A5O3LV7lkUv4K1zt9PF8348e9sEgnzH3Kei1/kvnRgdQretvzt3Hw8cNuwqAbd+x7ynWh8kEWD82c9n5tOn9hwVcX8JEAu4VhXNSc3f9UXdjTESQzM1qk40MjqGaJr95XvggrzY0lmsgfu2w+BgEqzZ0928F4gc4hMU/yI2F/Q80+ByybxttGL42c4LLUT59/sOiTgPGXNgIkkclWNYt9+D9sEaW+CavUfSA1Oz0YVF+jkxXvj+7vv+pg4REdKJbKMHfdB0qvMaSrFag2vPTE6Mu3WFClErIqQWIXYNiCcfp1pSMxeefHn6m/dgQETx8dfhRF355lNyBQOYBHnw0G767PwftmMs2zC2xi4apnf96sTo39BLtTHYiBAbGBt52Zxd9Ffzf9g9KGOW7546iNbu67RTwCiWh/DwzHj5+HERvC/FTRCZ2WeS15CfTQMMb1ytQTuMYYypiy7IqCMRosz42+R7EB9ZvEjihriGdQHzOnkPiq1rnEaVFtDXzlt1emqOCeMRjC9yA3123g/p8CEl60AQ5KrdJ6nPQBYiZP3vrcPb6eK5QhRWlvqGfcvoO9Ozeh5EvizxuxjHjV/ZkDnMzCWpQEphl1XSHuD74IBVdMEn6qQLMmpHhOTghtjIWtSDeZ00RJifMVzirS+y6Egmd/yvc/+Fjh7Sk2FhaD1/z4n0Ig13EaJJhPzcl8zdRivmPGu1fI5PdRIfRME0peXzEp0EuK10RWH8Zhl6JH3D8GMhrgjQ+7nDbxPEUEbP/YQWdHW+4Qptvsm/H/UoLlxUwDeMQhwFA1FJa9dtAsSEQ4E598f2/TadvfekyBhiAoT0lXkP0SKaiojXZtllAlw9vI1OH9IJ8O+mDot+BwQIXQ8iPMbhQ4CIJ+WwNnD0ooKrTV/w6iu6e8Oz5fWTetvqCEyAluCH7pvWBLXkhGThhj5GGilOmddgkcw2zEVxQxs0EVID/KKcXnMw7abPD8eEbJzdZ+9riabM1ZkTcsD1O+Y8Se+Y81Tnl2aIfjizhD42/dvtt5KMPQxwHWx6H8d4HhQhijbNGCNRV05IWvLv24W1zFahTTpxzegYzVxdtpmdo2HwSuKQ8AliM8JK+wwtoLOnTqK/nz6kK07zG8MtK6cpruG5lw3toncMPdUV3/n+qeVtAoSBB7+T9Nw8ZnD3sgnQLHmpcTFZG1QD1pmfhyUmA10NiuqE2hKhVqFNJv8mObLZ6nmD0njGFKFuFmbxssGZFJaNEgFRHhzveOPMb9C7p0/sCpz+q6EfdswFE+Rn6IcdBPv4zEI6e/qkiKjBTUB8NhEcBwQfFlXGspoH5dUJ4qbMOZVgQsa6KyLyC3GDotqizpxQrdAmF+ImCwGtFhW+TZgEUGbbZRs48RcvTb/DuEEwEK1hjDl75qQoYqWdnTGzi46hHdFcwNcGgryVHuqI7fz0zJH0xzNHR/cDUduC4ZnrJfndyoLZnUtzO8jIF+1zKRFZImO6GhPVDbUmwhhdRVj5tIQxQUt9kU5gLUvfXMy8USl5AH+mjftAt2WueD6dSHfPHNTOYv/EzL9E78NvCoJcODPVzvZ/N51ID9DS6ICxiZ4yg6JXMHMDtYx31qctNWHaEpFF1K+tMUai9kSoFWGVG8dGQLJFtwlzsUHIaeIey4Atk4K5InDD0DIap2XtkhLvmGlx0TXT/9J+75yhkyLuCS6qVa9j4iuz2aYPzLG5uJxWE0bWqtU4OWKSy3+S/GgCJyQt5UQaJjTro1w0rReiuQnrUnyYcwxNIwQIEYfF3UMH0fjQsojrnTf9FK2YebYtgp4zZ9apbzrccSjVgfjI4mbSuGASl8P3+eC06Ng1LtvXiUYQoZb8Cz2I9Slbw1HmhhqRagtXh3L8DAQkmEHm4PpMiPfQgRHrG5vaGv3/nOEWAUJPls8LYgbxaZykVzAPPM0CK7mgxuWYkyYYY9TI7TqiKZxQTT2R8aGa7ic3nutzKrExTVZAtzVFVCbEG4aPoMdpYcQB/3Du70af4TCSTncQcVJ0US+ghcRp4YN8IGqJzv1gjJFoDBHG6JIZpe6nGWmSdENN2e+lkcYGiKiSK/IYL597DK2bc2ikA4L7MQcEdwDxKomsPQX0WzMdSXM7yAga7XOHMaarO3Td0Sgi1OqBSG72dcUQIT/XOgObJykIOUsAc9lgrmg+y63Dvx6NmUVyGK1cCdC9gjn/MMZonC6pSraHMaarO3Td0TROSFr0Ayv1nPxrgrmI9jm4hlkqAad1r62lNoAQMWbJVZgzwsKa5OzuJbRmsJoxJqlKtjTGWDJgGmOMkWgcEcbRDy/I92SFNtMBTDEX4Sga7XPEXZqoc6s2cDoYpcCxWQTFQdNLn18SID6akTFmvifFMaJJVbKlW0Mx5jTKGCPRRE6oKt7SAKFZS6WIpkXaaEG/ZmBxnYBNjIMFCccgwLrpfwwYikyDFwhIixTiqB58ZvoN5T3MuFlqoDFGopFEGKNLAecAbVvWAnM8bAxNbNVO5zoaahg4WLiuTR0BrmYeeHAtaaKkFEO1dZDWUqU9wp21nABPNJYINQVclr7QjDDQ/ZLEUpzAph4Co4emz9QFdSVAsqyBxsWQXpZUH1SqBpq1dHJi/KwChtszNJkTkqaIXyKCt7VCv1Is1cRNWORM56+sWxLgB21uNZEfc8vJuOBy5qHSr8YYidom9foiS/IvFpaVfK0oFMXWPJOIsUHylkrsd2Deba4grbCWJFaXXq58/kKTdUFG0zkhacm/kttpUTBQ+tkHpRkOKBaLTN0DRFlnHbHXsBEgG5FMuAhQOvb7zRgj0Xgi1JJ/SURT2OJBofuxhQ7XaIYarVgUdMQ6W017BTjYbQSoWULltRqBkQhxsxhjuta8qWi8OMrIWqFNiq42U78mmlKK2qX9DlsdHcy5VpJCVnbTiiSb1zStZkxa9IM4yrjIfIMV+aQKbVJ0BbFp8acgTi0FCATMRoVBBcRzjQAxry4C5OLAJrAGkkgVdFXjazL6hhOSgxuSZ9FYsoihZKnWRpY6mf0Os2y9hG2eTQK0hdi51qyfuCD1GSckzUgjiSOpoYhcbJzumviJYADNksp6YpN60ucBJAaNAM0gcwlfAnQZY7Q1bjr6ighjI81G+Z6sSubKjpAbCBtN668HI4NtoyEFp5+tpxA7cdhoBxQCJWzuG4jtPgRIYo0wz5oxJl7jvkJfiaOMJLEUBGkrnWdeS44mNNgwNu4KHTKptGGTAJ06KaA9yUAl59JFgLLpzSCIoYx+E0cZXTuG40Ztyb8SnC5EsR5o031wT1vuHlwessx9EwHiwzPYCBBhgHKuJExXjivNCtczAWpZLZrhrV/Ql5yQchppGGaTlKTvwNeYVB6jSZwxKquvlANhuAxRsjsWJbh+JAbNGCPRz0SImjTb5HsyXA3uC58S72arMNf3bD5FCa33Xh3g0zcDoryWDc/g7kkMn8NOEq3FMr20H3VBRt8SIbUIEVXaflO+JzeJbzMYiErS4OJqz0ZK00sN2GxouNJLgkzSayVsTnWGPOAoISZXA3NBy3fu1Sqx9xP6mgjJIZa62i6bME95SyfYDvgQIwObHHqWrfVZEQDXgZ7r4tYMF/GRIrb7Shk0wMYYiUEgQlTw7lBwoLtxTGna1miyTRfZO8J2wZfjmACRR6+NWxLFQBPY2CccdxSddupyb4JjgEODI9m6IDFM3c93LhhSwpCt4QQumpwYvznV4BuIvidCcnDDtBuHYXJFH9cHxRbHq696b2rCqAJwxWjt47qewRA9yZNjmhhkY4zEoBAhdIqOkmoyUddHrNSgbUaXL0wCBIkwOC0ooCr4Eh7FnAtlJWWDGd/Dx4SUKFDUSelF0dfGGImBIEJqESIWdH/5nk/nXx+YYhll0DcpFiEhspZFlNjo0Dl9iY6hHTaQINC0VYux9YEjw2Xj5MT48Zlu3EAMDBGSQyxNiozxhdQ1GdisF0K/UroO+YL1O8551HIfKdbltmz9aeSTw++Bu+cx8pjuGYaFc3kjGGM6MWhEuJ6I3ibfk76xovrXa5yRUoqqvQLEdOisZvHjvJyP4WGMuUxrh9fPGCgipBzJv1mADY2W3VqTThDk2i/ckXtTFwGIv9BNtarjRR8cwRjTjbl1G1AFQELoOvkzMMygBCIn/+YRtSQgFrLlFZtcJgDLBi4Uc4Xb1t9dCVFCnL343Sut/evB9dByvOhyilKM1ips92Oakg8GjhNSxgptRcIkSBtg3Hl402ORbpeFILDpo9dxR1kJjgEp4Oq/vLXUJqLBGKNjUIkQVbqek+956CqlACLrxeefWXlCcKsRzj2VPSdyLfkZgxjaiYEkQmoRIuz0b5Tvuax2VQHcC3oaXkV0h4IvDxE3G759f2GidlowF7QccGu0tneDgoElQnIYadIEIAckwyXqDzIXpD5O6vXFZeZ1bAlEQLIr+TfADXD1pHZnRLRs0KdxoIlQ80fJ+MdQbTs/uPEOjDGKKPzE5MT44417qIIx6JyQtJNYZo27klwD7JABC5r/dXJiHInXA4+BJ8L4JH5CvgdfHYd7NblGTK/BB5glVrW+rZArxkAbZiTyVmgL6EQwxvhj4DmhQNfJzJ2bfCq0BcxCGmMstUgH3hgjETihQBnJv4MIx5w9EXTBTgRO2IkTzDfYrI6T3ZZCFDALqUNrh1YgwG4EIhSYnBh/BN1f5Xswq3OtFa3PfUAngjEmPYI4qiBJLG1CTmCvEIwx2RA4oY5bzHf5ZA9+Qx0IRGcCtFQaD8YYCwIntCAYadIhGGOyI3BCO7qKhPIJjxO/jiULewXZODUYY9IjEKEFkxPjXZYFJLxyByIulxhA7QRlS93REOXgQCDCZHSVW5AnfVIXpkEBjDEMzWA1OTH+oUGfIxcCESYgLj57r3kFN3AxyxsOGjyMMV1+14BuBMOMB6qs0NYkOIwxL0xOjB8wkBOTEoET+qGrSyw6D1Fcyt6361I/QYriFmNMIEBPBCL0gNYZSLb+MkvEDwJYFLf0VgzGmBQIROiPLiONTP7N0vasqZA97LV+G8EYkw6BCD0RG2k2yquR/Ms9A7WeDf0IiN5cAc5ijBmc06ggBCJMAa04rUz2RcnEfgeL3jDGKIWCX9D8qwHJCESYHl0K4A1f+Eb0/35P/g3GmHIQiDAltCK16PnH6OcKbQ5jTFfQe4AfAhFmQ1dGgKyp2cvOu2XBwxhzYfOfsjcIRJgBWoU2mfzLbaD7BdIYw/5RA8EYkwOBCDNCywyQkTNogNIvkH5Q6R+NEYwxORGIMB+6nNJcoa3qLktlQRpjpF+UEYwx+RGIMAc0p7TsOCQzDJoKNsbAH6o0ML2z8Q9YAwQizI8ufYhrbTa9Qps0xmjFjycnxs+qeEh9iUCEORHrQx0V2tBVl5N/m1qhLRhjqkMgwgKg6UXSmS3LPzQFwRhTHQIRFocu/YjLPfj0p68TZDB6MMaUj0CEBUHTj2S5B6lf1R0cjG4xxnRVGgjIh0CExWKVeTfONGhK8u9Nn7uy/W+LMaZZbL0BCERYICYnxtebd5MV2uqe/Ivgc7QJJ0vRJu2QCciPQITFoyv59+0irrTOFdpk8LlWvlA7ZALyIxBhwdAqtMnk37pWaHMZY7TDJaAYBCIsAZreJPUrqXfVBS5jTHy4BJSAQITl4TLzzqxnQe+qU/JvMMb0FoEIS8LkxPh15p2lnlWX5F8U8GVjDFcIMNBV7jGgWAQiLBddyb9S36qDWMo9NWDBlRUCGFq5x4BiEYiwRGjJv9C3mOOAA8n20lWDK2iTpWZMMMZUg0CEJUNL/gXHeWzrk9G/0XS0F4QoCVCW5hC4MxhjqkEgwmrQlXFw0QeuaTvxQYhVlkuUBIi0K5TmMBHSlKpDIMIKEGccdMVcQgRkjohyiZI4ygAKUJkEiLQrE6G3fLUIXZkqxMjoGMS7/c1fRKqTzLSAFdUSNpYJcId8/ZY17TZmFBuIFH8gcMLkxPgjjZnUPkAgwophI0QEd5uxpXmJEfe8+XNXdhCfo5XbRcEaWj0CEfYANkKkOLZUC227ff09Uf0aC/dqA+U0Ln73yki8NQEDjKb/xQgcsEcIRNgjjIyOYcMfZ/t1GzGmBYw/F37gmiTiA5YGS2jvEIiwhxgZHYMFcl3SCKDPXfK+cyILqi9AeNd//g41E8JA6KZbAwQirAGSxFMbzCpuSockFy7TQusCqkcgwppgZHQMTv1tFYzmltA3ol4IRFgzjIyOQTyEvvibBY9sjdZRKqD3CERYY8Q643U5CDJwvQYgEGGDEIus8Orz/xnPx9zznlAPtHloBBHGIho23fFiExYtrgUEBAQE5AOyxpA9do8QDGrv/qwVIxwZHYP6AjXobTUYTkBAQEBA8UCzgvV1ipDtGSMcGR2DZgeD+Rt7MoCAgICAgLoAiZ4f75VZuTJGGNvWbw6MLyAgICDAATDGC+MiXaWjVEYYa303F+3PQ1bBUUe8uh3AfMJxs4HMRx3xqo4E1oCAgICAYsEtPSjuSo4cZySQPL39F66UySx4ImaKpWmLhTPCkdGx42PmZ81V9QGKQiN9DnWJuG16QEBAQECzgGo6D2/cEqU2Z8i2NLExZoqFFgApjBHGgS43ZfkuNLzzzlpB5606PZM2h4KBO+PqnZjwgICAgIDywFa4xYtmWwqnBRgjKmbl0CALK0mXmxGOjI5hIBek/R66UV58/plOxodCKd/93ia67/ub6L7vbcoz1ICAgICAigDXFSx6Pla9VieqVinJDMidMJ2ZEWZhgD7MrwApISAgICCghvC1/qG+8trP35H2ATIzxNSMMK0JFL4+dPyyqc9wuuKBtX4kAQEBAQH9C3TouPT959DIqcvVZ4SmuPqKtWn5Q2qTqTcjjKu7PO5bmhaBLnhAjevDp/fhNV8MWl9AQEBAQARoix+9/HwrU0RLLI9eAowXUIHMt6qNFyMcGR1D4ru1iZYE7MJrr71E/SzlgwQEBAQEDCDgVwRT1BSplHzEq9K5kxG62nYxtA6wjMAAAwICAgLSAq61G669pIuvpDSZbpycGD8+6QIrI0xjCjXbrDMCAwwICAgIyAswxBv/+s+67jL5/U304TVf8rl7oqlUZYS+3fGgBd70uSu7QmMRALP6T68Pix8QEBAQUBgQeGn2KYd2eOEHrvGNOVmmlW3rYoS+TNDGoT/yiS+FfL+AgICAgFJg4z0pLJBdzLCDEfqaQ7WAGHDlt19wVVRzLiAgICAgoEzc/jdruqyRN916l09SfpeZdK5xwT1ZmCBqyZ37h15BpQEBfQHkPx16yIGRdIoyU0e95lW0ePHCXCWnfAF6gxlo585dtOXfn4y+hRqOKDMY8nEDBgXgOTf8t0vp+GOPbD/xReefGdHBbevuTpqF/WNe1w6gaWuEI6Nj1xHRpUnfBvHffsuajvcCEwzoF8iuJqil2G+dTOC7Ry3eLVt/2mKcwXoT0AcwmSH5u+iun5wY/xAxI/T1C2qq6JlvvyIQVEBjAA3utFOXR4zOJJ48gGtgy9ZYOxOF381q+2BCLnphhizBmidF/25pnxBMi+zMgkIXGC8OkAK6BAQEVIYcvCnyFzIjdNYN1VIkQmBMQF0BrQ7RZW943fJMWh0YG5gBTI8l9lkrFVLDBfM88jWvzsQ4Q+H7gLpDs1Z6plZE9UmHXv/mDyJA5rmkK0FQd3392iw/EhBQKrA3oeGhoHsa3xwzuu/G2s+glvvj+WNzcBpGCbfI7evuoQ3fvj9YhQJ6Dk1Zu+SKtT7WjaVghM7yaRefvzJyQna898FPB8d8QOXAgY3K9bZ6hCZwWEOLQVh12K/pACn7Da87LtKsfYUM+CE3fOv+UEgjoCe47x9v6PhZT4VtDRghomfemHSVaX8NCfMBVQGH8MXvXumlqdTpEAbjmPXpvTrSvEzAbMnvQyOF+dUENC1m4IiGeyz2Q/YSUY+5U5d3JTZr4D5zt62/O2iNAaVDS7g/7S2rXT97LxhhYrFRzfbqmasREJAavowPmt6NX9kQ+a3KPmARVANmhhfoAVppncGmXjBQvCAglA2s28o3n+IMQAJjvP7zdwSNMaAUQEi7+i/e23FrH/OomUfYBeRKmQgRZQFFwdWPjIHDHIyvjL2HwxsE1AoqebXHN+oNZtRJGhsYJEeIFsEowdgkc8O6wqVijgGBS5Da8aLQjzSgYGhCMeghNyMMCCga2Jgf+ZPzE7W+ohkfDuA3xCY9ML1BB2u4CDIycV8cIYpAImhwWQCNFCWv8KL49xDMYGqM+JvLZQVtMSAvsp4XgREGVIKk/mIkfElFmNzBYM9888m08oxTIs2kajAxmn4/mV/oA+lbbFWvaWmr0rdYBiIf4OuW00cun705ngXRoXd964HILJ0W0PhkXIHWuFtqi0Xuh4DBQVaLTiZG6KNqBgS4mB8O1Kv/8tbceynyK56/sjSm18on/GkUqML/rwJZTZYQBI6MNL5XtdIiCvBpsqkTLwaYIxhVFg1OmlI1bRF7BpHqeIEp3njrXa6yWQEB7QA1CZ/zxStq1AxJDVGjATbgUINEbwu3BxOBuSyrTwgHJNInzjtrRWFaEQ50mVOY1RzYJLBfFOkRRQkQ8M8gOhSaXNY5xFg++ifvtgbd4L4Ihw+CeIAGLdXv3AuucuUJ3+uVR/ipq97bFczgEZIaMEDQwpYZeTW/ojQ+HNSRee/bD9QiDaGOgDZ57qrTC2GQeTRGipnip676I6tQBYH8w2u+GNIyAtowU/1A5xd94BrXBEV5hEjFT7Q5aB0nQgpFALS/G669RDV95gl8wEZGCoVPnpoNrJ1k9WkFzALru/KMk6PAmjzMEXsBeyLD3RndAAAgAElEQVSLtogzCAJ50XstoH+gpU7c8IVv+JjUV3Ct0UeI6LikK7UK36Hg9mBCMz8wUMnhk5+5NfW+gNQPrTKrsxvaJkxy+P2A8oGzAMJKVv8jTOMwkWfRzLVSWgwwQ45UDRgsmNogBKS3nHOFaw42Tk6MH8+M8CwiWpd0tZZYH3yFgwP44xD4ouX7ZZXI8zA/HKTIP6siWTzAjTyMMStTTLJI4F6rr7g+COoDAs0149kUYtXkxPh62Y9wPRG9LekbMI2sft/ZHe/dvv6e6EAK6E+AAd5w7aWqnybLYYNDCww1bS5fEYEYAdUBh9Il7zsndUATDi5YFNKsMX4DvkQtwAb3WX3F2pCw38fAXuMCDQxPy8CdkxPjUAI7GvM6u1CQhfMGf2H/IYkBZjE/wZQFk1YaINgCmmYwdzYbWTV/CNgQtNPAFrQVGGJ/QmOCKSyVSycnxp8nyQipxQydgTNk2WxBM+wPFMkAYa+/+qr3pjoAwfw++ZdfCSbPPkUWpgjm9ZE1X0oV9KQdkBQYYl9Bs1Bij5z7h4lJEIwVkxPjbSmrgxFSixleCCXPdReNGQafYXNRJANMaxaD2RPmsKD5DRZgykTOoG8kKvbJ2i+k80XbGCIOTITVBx9iM5GT/1w0OTF+s3yjixFSCmaoRQ+GDdY82MxJaRkg9oKsPOJCiPALYKQ1ncMVA5eMLzTtgfzzzAJqBC2DIcVZ0sUEycYIqcUMnZGkZMkxJL9s/oAewyYtpw2CSUqmN4F74t4hoT1AQ1pzelphyrZXQ5xD/QEL09dvWdMVJeyZK0gcIap9YGWE1GKGxyNFy3V3LbWC/NvkB1QM24aC/+TCD1zjLcCkYYDYByiNFSI+A3yRZn+lYYg2N0DwH9YXEIy4S4lECh5zwuTE+CO2DxMZIc1Gkz5ORPsnXYfNddPnruxqrRMkrXrBloyMQ8TX91LWARUQoMFmuci732yHa4h1qBe09YfQ8vYLrvKxWr1ARIdzdKgNTkbIGBkdcxbnpvz224CSYEs+TkP0aQ6kNIw1IKCX+88mHAaLVu+hrU0Kv+69kxPjegkiA96MkFrMEE7GC1zX5Rx8QMGwEfrFH/y0lxkIJiSYknyiQNMGMQQEpIUvQ0zjj7a5C4J22DvkVKqun5wY/5Dv4FMxQmoxQ9z8s67rcqqzAQXARtxIU4C/zgcIhPIpmxW0/oCq4csQodVBu/OBJjSm9Z0H5IPt3ErhZlMjQ5OQmhFSisR7W0SpryYSkB1aJXbyr7/nfchEncevWFtpEIy2ryD1gxlzE92A8oDgOLRpOmH5kV21Z3thEvf1WfuOzeZGCPEO5aOAwMvEoBgbMjFCajHDw2E58Ami0bh78CGVB02qTZPfiQACV/h6L9MgbAKWBjw3GD/2WmCQ6cAMD/0JzSA4G3rFLHC+4Jxxme+xByCI+0AzzQVTaXnQhPcU2rhXUIwNmRkhY2R0DBGlv+m6DhGlZrhykLCKhzbPvmZLED2I3wXk7CB3p1dIagPlC8wJa5ABLaaHeX3D65ar3Rx80Wua9rVkgJn5lPHT9lpw8RQPW3EWz3JpUSulPIPKzQgpRUSp1uk+SFjFIK/mDUnM1REChI8DoNe5gEUwQhMgOjTxRYeLQTjgoq7/717pren5og70DBqAadNl1YClAK4CF0LRkHKhad4p4hhumZwYvzDvAAthhNRihh8nIif7DmXZikceu7qvSanXWqBEmjzGrACzR8unfmGMZTE+E3USbH3KtvkKdzZBM6RYZEcBueeXTU6MX1fEWApjhJSiRmlOW3CAgCat+s6lrykUQkoeX+AZr/gPuuzIJzrHODVMW1/cjzb9cjFtfXFh9P8X9w173U+TIMsGhLWr//LWxhx60IbABKqeJ+C0t6z2um7R3Cl6zcKX6Nj9d9Dyl++kIxa9RIuGpzqu+epPX0lf/cmhmcfiK+j5mkrNLugU4h0yoYCgmI7uEXlRKCOkUJatUtiYoI//wkdaThNYkIR3vfrp6JUWz+yeT5t+uYQ2/3IxffvnB7a/3QtGKIE5vvHWu3zrG1YGCJhY07K1PhckI1z+8h106q+9QKcufZ4OXrAn9b2w9n/2o/+Ue0w+pn/f/oeaHz4wQ3/kNDXnCoqxoXBGSAWUZUtRRHVgoW0mXxOzT5eIIk2h73rV09ErwlD670eH4f+aPQzv+8cbChlXEQBTRPPgXh2C2AfwvecJcCkaZ779ivYe/PR//jc69uU7s/3CDNHmHZ1rnwc+wp9vQQhNGAvM0I2crrHcQTE2lMIIGSOjY0ivOM51XSjLlg6aNu2rCfr417J0Bk9CdBguyXgYUvdhWCdGKAHzMfZs2WkaECA/ddUf9VQrToK06nQIQRmwddd+NPbofy5sbD7uAN+zJzDDdMgZLFlIUIwNpTJCCmXZCkfZTND0lbAEh9/YsvXJ6JCH+QL/37L1p16BJNf81r9FPqCsuP/5/ekTW14TfTtNDmEvUUYaAdbu0vefUyvtT0MXIzwsOyMEVj54otd12Bugj0MPOZBOOK71b1ibzMMW78HXlwRfZqj5DIN7pxvaPKWgkTWTE+MfL3N8pTNCShFRqjXPDDk7nfjHO67tOgh9bOtZmCBl9Mdhzd5yzhXtv//hdx+yX+xhKv3bpw6lrz7VCphoCiNk4EBFV/U8+7eKKNkiIQ+4Uw94nv78yK1+d7ccRb//z7OMMMt+1LQOnyAaX2aYlSYHARBGbv7clV3z41vhquigGBvmVLEWMTdf4boOfimzJiAm8K6vX+vdqLOfgUNAC992ERyEiyxMMCu2mBGmMwmv6YTXTPfhCMJqEjDv2L/whfsULZcAA4QZuElM0MTOqeHutbetuWWfHLtkR/uuT//sF6nHoDFOHwEb8651tTdxoWK18onG7ndAaL1dSTmBkODBBBEUs6wKJkhVMUJqMUM80DLXdTApwNlu5vWg7Jcr6qufoYXCI5jFZYKBuRmadhKSmGBexnPI/D3JjNCDSSK1ggGzVxOBKEMwRJ+qJ1ivJjNAmCXb0Bhflr0Qo0gtC2eMy/WCtdA6t0hgTGZiPsyA8IkNKuBS0YL5cLZ7rOETkxPjB0xOjD9e1fRVxgipxQzxYEvxoEnXQUqDaQ0TJ4EQaFe0Yz8CAoBJjKi84IqsBeN0RcnB9JOkCWYJxX944yxzPnj+7uyMUNEImw4wNxuTg9UDn/loIU3B5p1Lcq//Efvld4vYOqhwxGISfPIxoeGY0aYIDGmyNp8VEPbMyFCcMSiX5uEiuHNyYvzwqsdcKSOkFjN8Pn7Qe13XYuJw4EtgggfN7PBRpZ2Vq/xQVGbKMU/w41QS4ZZHE5gh2vrSwvatOrSNBgOHBQII2FyKtdK6pTcRi81gnjyMcJpo8ZzZJPsyglA42jcJmlvCBOjJLDyBdW6aOT8P4AIwmT8i0D0jQxEUc1Yvxl05I2TEnYOds4MD35S0IJ25or76BSAkkwA/6RPa7Qgo0SRYEz59CDUgmpRx7KKds+fajP5yHYaoQtOPgLYNcym0wLqmQmSBmWy+eedi5xrb9kZRRgGXfxYCocvC4qIpis6rL3a9h1SXfgfmF0FDWqEBpGN5YEXZkaFJ6BkjpBYzRJPfi1zXQdLSbPCY+H6WtmAqM6UrEKzL0QwzalJwEcwTPsWGs6LL/JH1EJwh2mmUXesnhjEwcKyxSxhavmg2WCarRnjUEe5gO/jck3JAQVM+/kKzEAWYQz+bSCEwQ6AzBXZUpfK0OFUWFGNDTxkhtZjhzT4RpTj8EW0kgYlHVFJWzaXu0AIrXCYcCAguvyD6CPqgiHldvt+O1FGC8rXtpXrnzAXokHtn+54FqQOkul4VYbWjk71PCTtolmZ8w6UOmmwqEEyklXlEUIxHYQnEiiytMijGhp4zQpqNKF0ah8xaAWlLiyjFQrgiI5sGSJCmmcGn5NlH/iQ5KhFEWnYz3S6pPe2hZwmWGSRfSz9h+5752dd+huiYhZ3FGEwm4wNf3zLOFpew6aIxiqszSUBo77dAPwjqZmAXgmIQ6OgRFHMvYkWKrhmaFbVghDQbRHOAb0SpGemIBfEJTW8K0DJHotUWKNmHgSi1JC0Oc5emfmgRjGfR0D63Xcx8Tc++Nr3Y/NSJQUSHad5Y0+iVdk8IlJ2oDnNekjYDGjNLhZmABcs8o4ruodlLFBAUk2xjrhi1YYSMOKL0Ttd1mHDT/oyF6YeIUqRLmOaXGz0KAbvML6hwkgaHvjI94zGJf9mCl3KHzwc0DzJydPOLBaRQvGxXrjk4yrCuuODSCn1MnTd+pbt8WNO1wgKCYlb1MijGhtoxQmoxQ4TQOsNCMfmmhoNgCixU2ioedYJm5vXRBpM0OEjRvSgGPDMdvzIoAXht/ZVInehTX3A/wqS/rOvPr0UyhWJj+oCZtPVZ4T5ICkoDrbm0QrgITDfEeatqpQilArR8LSgG1a1SBMWs7/VzaKglI6TZsmyrXNcllWVrok8JYzYjI33awrgILEsB6CwRmtKkdOzC2Wi/rJrAi9P9mTrR75Cm0c278muERSCtcOwSPn2YmnkPnE1NrJAFa5uZ58pBMR6RvLUJirGhtoyQWsxwvW9ZNkSUmkE0iCht2qZbecYpXe/d9/3kdAkwLJdvsCptsMNJnvfwMw7BfkmmH0jk3APH7ldNCoUEzPxJvwWaM02EJjS6W9mwVApEyprxF9B0mxgUY0OtGSF1lmVzRpT2Q1k2k3E/Frc+SvMdE7etT9/kuAgz5LG21IkUB+Dml5bkHkdA9TCtCc/sVSJHk17anukBXAKkT36gWR3LZVKtExBzYeZOYk482+NdX7egGBtqzwipM6LUqyybFq3VhAK4MIuaEqZPqxJNi5TI4lPJig4J2nbQ+XScUExiXaW7AhqDZ7RcwhT74NiXzaZQPL09fQcKyijcuRihi/aADco96u7v5qAYrdC/Z8P0i+KCKY1AIxghw7csGyJKtQK4dS/L9obXdTfzd5mBsFGTfB/QlLO0Vyoi2CgKcEhrBhOH4aO7OrVBlxkqoF7oTKEooAtFjKr7/CXRIOjE5UvXvl9nRpgUFOPym8Y4IS6U0hg0ihHSbFm2y1zXITjElFy4LFtdI0q1g97FCF1+s6r8KdrvLZv3kl+KWMlBEgG9QUcKxUvJ9UZde+QVw7tzP8NRr8kmSOWlQfjRzOjRuvq7cwbFvBAHxTxS5hjLQOMYIbWY4XU+Zdlg1kC9OwmOKK2jRGbm7flocq7nKKNavzc8JX1r6sSe2YM0pE40G9FSZxWGZogOHt7T8fzZrBwLPa7qhsu14CM0/sww59axZi5iKcygGMRcpAiKOaDuQTE2NJIRUmej38QgGgSa2Mqy1a0QrkkcWbpxm8h6jywSqxmodMyCHbkiBXf2adeJQYEUXh79VT1SKLLAxXR9LExb/r27rGGd0rsQFGNWvkGQD2IuPNCYoBgbGssIKY4oTVOWTesV5ipQ3Uv4+EJcmlIWyTkrusZb4MEXNMKGI+9eQMDMApFCkSEALI8WlkSLPntTs8zUoWQgmDhiJ7TcZVfP0xiNCoqxodGMkOFblg0hv2YUGEKD61CWrW4HfV7TzRHzduVOnYi0iIDGQloVosIIaZlfjzpQaMgaqVpnQCONCo8Y5RwRFONZgGNF04JibOgLRkgpy7LZGv3WLYjGJ2I0z/eLhpTSWxGjyQW1uwsx2zXCJpfMCyDaunehhdkl7YfO1zHzZzXCnS86fVYqyhI4swiOvRR+kXuMgiMScB+hMEmKoJie9hAsEn3DCClFWTZIO2ZZNu4WHlr9FMN0MtWUnJ7peG3ePasRJjUaDqgnzELX5vpGr2wNKHx63QVYgKAYFBqR4KAYD3fMxiYHxdjQV4yQZsuyneC6Lqks26D7o4pInTh2fr5AmV4GRwQUAzMP7dHd+QJmDp5TRArFYAtUOYNibpmcGD++rLH1En3HCKnFDB/xLcv29guu6op2RERpPzTR7GkllpxM8Jl98ztuV8dw84CUyLknDp4zm0KR1ew/yNWJcgbFXDY5MX5hWWPrNfqSEVKKsmyIKLWVZet1o9+8EaFZpd+sGrEMKDgmp0b4zNSCTGMIqBc6Uij25EyhqDGyRGdX5cOHuweFRMygmI984ktpgmKuK2t8dUDfMkJGnN9yi+s6lGVDh2UJ5BmiE3MV6Gnie0Ho8C/kNYuKg2/QzVl9hRz74Zi5OzpmwkyH8kHWii553SW9CvbCuOHuMc3UcAt51DHuu6AYG/qeEVKLGV7oU5YNHZbNsmwoe9arsmw+RJs3slRD1lJUEkfMUdInUhx6kfYQIxTbbi4kAyk6hSJr5GjR8BFiNb/7lq3lBvzAvQM3jwTcQCgw4hEU80Q/BsXYMBCMkAoqy1a2ZpLFvOKKnssiAWcpRWWOfT+aUqJCLS8tSlDcCwcGqt6b7WwC6gvsB/ifNnz7/vYYt+5bmBAx7Lc3lg3vat9v585dqZ8/i2Do+o5PBKtGhx5lyzID3XbMoBisCdxAHr97Z5ybPTCYO0gPCxV/ZHQMZdkQTLO/7Touy/Z1w6SAYrTQGMtqcos8PEl0PkTrMg9ljQDNjTQ+HeVaGSwDwkXVe63yPfwf6NpxwvIjG9XnrR+AvQdagEbkwwwOHtpdaGI8ypZVseYuYdLHRGumZZVZ8QlBMaY/EEKJpz9wTZyGNlAYKEZIs41+DxgZHcP/f9N2HZdlg49QdoVAAA1KI3luqlTQTCUwLSWZXlylprJ06M8iNctxRGHuOYMbLln4ePSS2DUzTJv3LaFH9y2hB/YeQM9ML4hMPBqTZAYJP29o35QPMKfd9a0HIu0uyaS2aGiKTp73XOTLO2Xe87RwaKr7opz7YumcvbRNuW0aYG+kaeXkLGzvoEH8nsmYyugRit+5+XNXdvkDERTj09c0Dorpe3+ghoFjhAyo/iOjY1j0NyZdh7JsMDNIyRMmB0iJCLApEhrDAyNLYoQ4pPB5ErGCsVVZczRCCVF+C2mKTp77fPR6z8t+0vHZz6fn0/17l9J39h5I26YWqgwSft7TTl1OF797ZdfBFNACM73b1t9tNaFB0Hnr/GfolHnP0Svm7LHPXAl74IChve1/Y99fRGcmXq8BgqwvIwRTSaItjMFMvzKRpc9oWmCMpj8QgJvHQ1tHUMzxsZIwkBhYRkhxROnI6BjMAInZpMizgeNZ2ty5LBsYZVG2ftwHDEtqZGCECOJJgosRrnzzKd6MMGt0nAxciPK9Kg53f8XQHnrr/O3RS+KHU0vo/91zIH1n70HR/MKUJ03bkKKxtnXrRFIVsC9u/MoG68EMoeNN85+N/q+i6rSGin/vvFXJTRV8GJpmlSmSEZ63agWtft/ZHe+hUAhypD3OJgTFDJQ/UMNAM0KKy7LFZtKbkq6DKRSbV0pd0CrgR7zwA9cU1jXb9BPiN1zm0dvW3ZNYAACHvBkNWzSk1PnM9Hz65u5D6IjhXXT08I5Sf7eNIf1t/P7R++2gS/abFXahNYIxwsSKdcPc8PyAMV76/nP61t+YxPig6b1zwVN0ylyLWdOGCpjT49MLaevUfvT8zLz2e1mjLl30JLHyjFMSPwftJUHrYG+maeUBXDWmEIc19rRW3RnXaB54DDwjpBYzvHlkdAwBNA8nXcdl2WSxWphO8DdqlxYh5cEkZUZ7YaMn3RvSH3wASf5A3NMsNq6hiMhY+O6+vPvXE685ZnhH9Fo2Z1f0/1QHr4aEw3jIYJJvmvuL6MWA1vg/dh9Gj061GKOstIG5B2M0/S5FAutX1v1xbxzWmk8bc/9/vuwnurBizKdZ67NIYP4fjV/bphfSizN+fSjLjLoEIAwl1R4GzZklGk2cd1Z3oLqnv84JM36BYibrsiDFGMigGBuGZsrc4Q3DyOgYKtE8nhRRSrGUh01o+pkQ4q9FNqaF6ZMEEMWaRPggiKTkf3wX93DBNAHnAQ6JLVufjLRcSO/QGn01Z2aQJw8/V55WaXLIGHfvO5C+tuewiKFLQJNA/8qig29Mc3heYN4/+Zlbuw5cBLO8c/5T9Afzttt/oYTzANrcA1MH0KNTL4+YnQ9AY5hvRD3DH48C3kUJC74aE6LEkwRDuEVcEaNmBCeux/fyAHNjRrRT3FnHM6J9VVyTOSBG0AgF4uTRA2LtsNvDHYPLsqGArTzAYKfHIZnXDAkJ3mSEkCyTIlVBYElaIYjHVyssCiBUzI/rkMfBBGYJrZc1X2gGeH1z7yFd14NJvmnus3TMnB10+Jz0uWRtWA79FXOepRX7PRv9++cz82nt7iOiAzwKzogPMRzSH/mT82sTdGNjfpir98z/cacwUUJvP8zTA1NLo5cPswODwRwi7QX/L1PjzgLQXxITxDy7mCCsCeb+yCso5wyKAZYNclCMDUEjtGBkdAwNJy9wXQcNAc19JYqQ+kwmC5z2ltWJ33FphQBSQpLMOdrv9hJRVOzGLXTf9zdFjChJK0ae2lvnbo+0SATPFA2kb3xq71FdB70WrJAGeTRCzRQG5nfJ/G10+FAOIcECzMF3pg6KXhBUkgChDAc3/l+nKF3sKVe3Bbg7ksyiWbRB0B3oLyvyBsXEkaEDUSkmLQIjTIBPRCnFkp9ZoDvFBlWhSX4+9n/NeS4BSRZ5RWkBjTIyUy0/KjogIC33Oj+PE7q/+72NVpNrlNs25zl60/CzdPSc4kysj88spE/tOZKemZk1n2JePnXVH6Wel7SMEHtr9RVrOzQAPOcl87bSa+cUd85By/vm1Csjpmfz23FKyhtet7znAUbYDz/b/oso0R5CE4rAZwliA7MB07EBe85l9dHOhDzFOHIK3PfGNZcDLAiM0IGR0TFsIKc9owCTRRc0XyGCdVzEjXJwSbVRy6yOQ7HZC8yAzV9VM0yUYtvw7QesQQmLaCpijG8d/lkhmuON+36DvjnVacJ1CSQSvowQB9/qK67vEK7wHO+Z++MoxzIPdtFw9AxgepK5S2A9cRiD6VVpysRzg4b4/2UWqC/K1476xHKOfLRQGzQrjQ8zjhGCYjwQGKEHRkbHkGezzXVlAU7sDkDDkBGqFB/yrv5hYJ5goklwmUjLRtU+IhdzhL/xncNP0tFD2bXGf5o+gNbuO4JepFntyYchuhihxgAvmbst8mVmBbS9r029ir4zfZB6B6wJxl12fiX2YKtE25MdPuJewWUSBe25at5q2luK6i5t2M6TFEF5ISjGE4EReiKOKH0kqSwbI2etvw5ofgEfxuo6gKFVQrusK9i3VJZGyWkFtgoqxwztoIuHf5zJzwaz6cf2/XYHQ9S0e4aNEWoMcPVwNgYIxvd30zrjw4GLfLlzV51eii8P2hCYAJhcUakDZeDqv3hvYgqSjxYGAQ/Rpmm/53MfIEWa1glxg/IADwRGmBI+ZdnIcvClSHTtgJYv5EqnIA/pNguB1gE4rNgvVaQmifmAsGKanmFK/YM5P6O3ztmeygQJhvjHU0e3/7bVgtQYoWlSjxjgUDoGePfMQXTj1G90MGSKGR+ikFE1paj5Y83uu9/bFAU2lZ3jVzQQUZ1UlMJXcCwiQCZnzAHKpR0egmLSITDCDBgZHUNLp0td39Ry8rL4CjQTqY+jHIccfBVJwMFfZUpFmSiSQeLgufHWu1QT1MlDz9HFc35MryA//+LfzxxCN07/Rvtv03QmGaEpLL1p6Fkam+O0ykeAn+9r06+Kfs8EDteiaqy6zMxNg8Z4TPi4EjQrTFqTaAiK6Q0CI8yIkdGxC11l2Sg+nGFykQBBpS3LphGrj0bnk1JRdvBML8FdKPKa/XD4X//5O7rWDCbUK4e2ODVFMKmPTf82baNWyoFcT2aE0nwOLfSv5jzqZLYR85vpZn7Q+iCImYdqGrBJE8JAUSUE6wbMO4JRkuCTKqG5MFJUeYmQMyjm+smJ8Q/Vc5brj8AIc8A3olTT6CidvT+CJnH6MDGf4Jl+ZoYm2DR45pu7E559AMb1yb/8Shdz+APaThcP/TjxDn9Ph9CNMy3tkCONcb8N37q/Pf9p78PAc3308vMzpTFAOIOW189Mz4QPE/QJjtEixtO4QWyVqlLEFVyEMpFePxagIjDCnEhTli1nBFjrekVq9GGoPuafQWKGJnCYwXSYNrEdhyQqukjfDbS5/zrzL/9/e+cTY1V5hvF31I1IurGpbXQxaCZp0wSGTVVytbCwN6ULQaMrLUiikPYi2Br/YCJOE//UaBQ4NlgSBHUFoYwbmlMXDnqidSVD2tUohUbTNGl3xqRplOa5nEPvvXP+vN/5vvP/+SUTzTAz99xzzj3P977f8z2fTMtXsWHg52WF/EouzR1Gy1yi339CluRHEj+9A8PLC1Mzl6tKsaj8JsW3a2hEUPN5iBvkmswLOhgk0xTjAAqhI7Ji2SIs2x9D4lypmvWFGjFs05yhDXm2Z4p7cG67+Hf52cXl2Z5fTV0pO6bWjBlZDl5cvNQKnfhILkx9Ww5MrRr7HlruqP60c6FZ2y11CVeDwqTBrcbIJvbTJjTFOIRC6JBef4A1O3dm/UXLrVMSP4CuxLCpbtIiMakYcS2fnPv92MNww8V/yeCbcdML5vd2XHlJDA9+vbhsPnAogFeMC6B2oT7m9yB8Xa34kshyh4qlCGo+g2JvpFsMfG9W84NEB4XQMdpYNsvcQKsPoqYtBOs+LPwk/txjjjFrl464dYCTgggx/NvUCvnhxf8v5J8UQLzegRd3Za6nxMN7/+snGrd0oSyy1gkCDEazNrFO+uxp25lxXSFNUEbI0cD3tmp+kOihEBZArz/AZpcns/5yUiybdlSZ9IHUxLqhtYoJ+rQoNjxQ4ZjDSJUkg0HNtvt+mtimjF0Y//U5Wf/N+LrA81Mr5OmrfnC5XaoRwLxBDV0C1wXrN9PW1GrvdRsRdGCKeSTwvVc7dOlKg0JYENpYtqRF1tr1R7aj06xF9wAWcJe7areZtJ0oJtvf37n4H3n5vx5Mq88AAA6kSURBVH8ZLr14+qrvy1+v+Nblf0trgeJa4MHJyi8bTfdDu1g+ydiiGbg6MMVsCHyPH8KCoBAWSFmxbLYbBWel7QtbpcakLWVIG+QkRWuhqsS8Y1eWNrhA0wrF5wOfkyziujdaY4tl54emmBKgEJaANpbNcu7AypGqGTmLcl0VGQeV3a4dd49V7XHmqLhUEdPlNeRSiARaymltf1HOB0qKsQWt1Kyq3OZ3aYopDwphSZQVyxb3MNX+vmYuRcLqEPvhVbl7RRNBtXfgxYcvC+KoOWo0TzZuv0GiQ1MFogpDJae5f+MGl1qHt2XeME0xJUIhLJFef4AIpFeyXtF2o9+49UlisDcihBSCmgXnDvMx2srGIAUPZjxsKYD50aQnicE9mzT3rp2usNyBhnsIlgyFsGS0sWy227AkmXC0+Yf4PVQvOI40IMxwRGZlMZLlRBXi0rkvOp3yYgPuUwhWVhvUpIuRZHhSubEtzW80xVQDhbACbGPZTKLQ4tozJtWldqRt0m4ixBbtQE0M57XjtjzT7v7gwBQzG/jeedWBEqdQCCuk1x+c1zhK4z6cJsn2Sa1SkzVo2kQTzh+SotHeiyYJSUmfEa1ZydIUcyHwvWnVgZJCoBBWTFmxbJIgqCZbQpmMwimIxDVFDMaSQgtMuiaWn813At/bpPlBUhwUwhqgjWWzHHUOSRr5moyetfZ0CR9Ke+YOMZ2G5MJk8GU6Xx33eRLDJSuW3RqaYmoChbAmlBXLFhE3dyiG848mgoiHFBaEa9ZtEWJ6b5kIYFpowWQUXhIO5u9piqkRFMIaYRvLZrrRb9LfMbXxmzy0hLtbkBS0S3ckhwAmJTCZ3u9Jg1Ht8iQRWUVTTL2gENYME0epZYDvZZLapSbzh2LYxhIuvSAhuIef2/ug+r4xnX9OCy833YzacteYC6EzlHFpNYNCWFPKimUbJWmvQpOWUYTW2BCBShbHTHNNN8CgCbFzJveIaSchTQDzdCUsTTGnA99br/g5UgEUwhrT6w+OiMiWrCOMm/TXrn2KI0nE8gQ/Yx4S4dPatinAwuNnX36bothCNBvjjoLBF+4Fk3xb1wIoNMW0HgphzSkrli2OJEHMEwWGCgCCmJUDOQlEEQ8buk6bCa479mrM2t1kkjyDIcx5P7/3IacC6MAUsznwvXnjFyalQiFsALaxbAaT+LHEBXlHmM6xSGiugchq54QiUInuO3iCu1/UHLTqt92/cWgqMQH3KO4n0zljvA5c0HEbI9sYs2xjDmmKaQ4UwoYQOkrPlBHLlkTSHKKE85IYwZtWn3hoPvXo/Zk7XsSB93P4rVOsFisGZhcIn8l8XwQGN8++9FauZTVpAzTbnfstOyw0xTQMCmHDKCuWLQ2MlOHym3SsSviwgCAqA4bHsBFFCdtpWAjNtYrFYiN8Yil+WfceDFcmS4jiiBNYgzl3mmIaCIWwgWgdpS5i2fK8xuhrwVyTZ44SDzo8kEznFEfBA/fUu3+WP/7pY1aNOUFnYeMdNw/n+PIOUMRyrhddjoe3JztMbe6zSWw2txaRfYHv7bY+CFI6FMKGUmYsm4a0eRoJq1G0qvK+Jh6CeC82D2MJXYgffHR2uO0RK8dx0EHAeb593Rrr84xBCK63TTs+KQJNwuoP88Wutq5KmlIwiFt7IPC9I04OhpQOhbDB9PoD7GD9RtY7iEvCMF0sb0LaA0wciKI4FMYIHAtaahDJTxaXWltBotJeu2ZmeE/cdutqo2UtabgQPgnvnXs3r08cUOHv73/9hNNBnANTzNrA9844OyBSOhTChtPrD2axHj3rXUAwjh+dW/Z901g2E7JaWmJhspkkr1NRC45v6dznw3OFhz4cjnVLxEFF993rrpWZm64fnoeZG29wJnST4DzAqGRbVeP4IH5JphcJW5+YUyxi0GZpisEegtM0xTQfCmELqCKWzRSNKKIKe+6lt50JM14LX0WJo5a49wMh/XJijdzKa66OXVJSh+NHJeaqDYn3g0HL5FzcKEWKX0TStME9P8+ccRCaYtoFhbBF9PoDtGfWZL0jS0OANRDFezdtSG2fRscEgXb5MMQgAAYcCKTpOsa2A3HGOYexxWVrWFP1SUFtzyQsowlpimkZFMKWoY1ls7SIOwUVwp5H74u1xI9ShDCOggdjNH9WdRVWFKjuhl+LS4WZhdCG33jHLalzfRJWX2ivuqo0NTjoijwS+N6rpR0wKQUKYQvROkqLiGWzJaoWsx6iEgo3HH1lPUhxPDM3Xj+sJPGwx3+LnIfTEs1foqKL5i+Xzn1RWlYrKmwsr0hrdUZAcI7Nv1fJ/eVgnpx7CLYUCmFL0cayOdhbrVBMhFHC9tb7H54ttcroEhA9uE01i+khxKfe/Xg4WClyrk9D3FZjBs5pmmJaDoWwxWg3+i0ylq0I8BDe+JNbVBWIhC04zHsNl0fkSLzpIqh2cZ4hIFkt69HzXHarU4OlKWYx8L3Zig6dlASFsOWEjtIzmli242/OVeIotQVCjioF7bm4nQfSQHs1EsmilpHUFYjdcD3hutXqQUUEhOT4yYVhck9VbXQNlqaYo4Hvba3o0EmJUAg7gjaWDekw2ENwFNexbGWRp6qZBA/8TzHn9tkXQ6H8xz//XXmbLwvMhX3vumuHIhfNZZoOECLQPkSrGUEDTaumLQd2NMV0CAphh+j1B/hg78p6x5atpNoDcYBI3L5u9fC/mrlHU3C+IsH88suvhkKaByyOX7lyxfA3sc4wr6ClAbG7VBF/Ku9/uFh7oc8C1/fI755Ydl33/OaQVsxpiukYFMKOoY1lszQXNJpRRyiWU8ApWoRYlgUq+qGTNEzDqYMJqiiSzF/3bNmrNcXMcg/B7kEh7CBaR2kVsWxNBKKJai1qSYrDSg7CNZpAg/V/IGrR4t/aLGwmWAbMXwh8b7oGb4NUAIWwo5jEslmm8hNSOJZz2+8EvreJV6m7UAg7TlNi2QhJwtIUMxf43jM8ud2GQkgghvMicmfWmShjo19CtNAUQ1xBISRDtLFsWKu3c/tdY9+rOpaNdA+aYohLKITkMr3+APMkJ7POiOVDiBArLAdjNMWQZVAIyRjaWDYHbSlCjLFsz3MPQRILhZAsowuxbKR5YPukyWUox+cXZP/BE5r3QlMMSYRCSBLRxrJZ5jkSkoqDUPjNge/N8yyTJCiEJBXGspEqcbBN2CqaYkgWFEKSSa8/2C0ir2T9XFIsGx2lJA+2ppjQGco9BEkmFEKiQhvLhrixw689vuz7jGUjJjy84265Z9O4r4WmGFIUFEKixjaWra4b/ZJ6YZliRFMMMYZCSIzp9QfnNY5SS5cf6RgOcm0fCHzvCO8bYgqFkOSCsWzEJQ5a6msD3zvDi0LyQCEkubGJZTPYHoe0HAyUMGAaxcAUg7i0aZpiiA0UQmIFY9mIDXGmGOzBiEGSAppiiBMohMQaxrKRPFiaYvYFvrebJ564gEJInGDiKIWJhrFs3SXpHqAphlQFhZA4hbFsJA10BY4fnVv2EzTFkCqhEBLn9PoDjNa3ZP3duFg2g/kh0jCSkoe2/uIF7R6CNMWQQqAQkkLQxrJZOgZJQ7DMol0MfG+W15oUBYWQFAZj2YjYt8GPBr63lSeSFAmFkBRK6Cg9w1i27uHAGPVI4Huvdv08kuKhEJJSYCxbt3BgitkQ+N5C188jKQcKISkNraOUsWzNJi48gaYYUmcohKRUtLFsSeYKxrLVG8vrRlMMqQQKISmdXn8A88MbWa/LWLZm8fzeB6V36+qxYzao5GmKIZVBISSV0OsPMPL/JOu1Hcw1kRI4/uacjSmGewiSSqEQkspgLFvzcZAfS1MMqRwKIamcXn+A5RVrso7DMqSZOMaydQ1TzGzge+d5XUjVUAhJLdDGsllu20McYWmKuRD43jSvBakLFEJSG7SOUsayVYvl8pZ3At/b1LqTQhoNhZDUCm0sW1JbbtsvfytLn33Oi1oQloEHNMWQWkIhJLWDsWz1w8G5pimG1BYKIakloaP0jCaWzdK6TzJwUH2voimG1BkKIak12lg2y8XcJIF7N2+QndvvGvtHg/nYC6EzlHFppNZQCEnt6fUH2IFgV9ZxWu55RyawNMWcDnxvveLnCKkcCiFpBNpYNstd0EkITTGkS1AISWNgLFvxODDFbA58b76Rb550FgohaRQmsWxxD/QDr/9Bjp3MXJ3RSWZuukEOv/b4srduMICgKYY0EgohaSQ2sWzBR2flyblDvPAj0BRDugyFkDSWXn+AFtydWccfF8uGh/zOx/Z3fvE9KucDL+5aNh9IUwzpEhRC0mi0sWxJbb8uV4dxVaCYtY/3Bb63u4hjI6RMKISk8Whj2SRhSYB0bBeLuKxWCcPLdz62T5vXSlMMaQ0UQtIKTJJoktqB0nJBTBJAwzYxtk+a5nwgaRMUQtIqtK1SCdulz+19cFk8m4QL8ffMHWr8HCJE//m9Dy0zDEm+eVK2QkkroRCS1hFWhwsaV6lkiIWELUNUiU0RRbyfp35937LIuYgcIs8qkLQaCiFpLeEC/IWsNYejIJkGIjK5/jACVdSxkwtybP692ux9COG77dbVsu3+jbHVbUTOIPK1ge+dcXCYhNQWCiFpPXkEUcI5tV077k4UxQhUjJhbfP/DxcJj3CLRu33d6sSKbxSLXTgeCHzviMWhEtIYKISkM4SCOK8x1EyC2DaEesc5TtNAGxLiiDYkKsilc58nVpIQuZkbbxj+/9o1M8PXTKvw4sD6v8NvncobJYcW6HpWgKRrUAhJJ9HuaJEG2qgb77hZVZkVASpRrPf74KOztm3aoyKym3OApKtQCEmnCY01RzQJNVpQycGRiuoOld3Ka66OXaqRxmgliS+InmOzzmkR2cpsUEIohIRcJhTF3drlFw2ElR8hMVAICUmg1x9MiwjWJW5p6DmC8D3Dqo+QdCiEhBjQ6w82iUj0ZeRCLRiI3jxjzwgxh0JIiAPC6hGZp7Ph148dn9fTYYQcvhZY5RHiCBH5HyX/7D5by6uQAAAAAElFTkSuQmCC');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
    z-index: 0 !important;
    pointer-events: none;
  }
  `
      : ""
  }
}

@page { 
  size: A4; 
  margin: 15mm 10mm;
}

/* ✅ Cover Page Styles */
.cover-page-container {
  page-break-after: always;
  width: 100%;
  min-height: 100vh;
}

.cover-page-container .page {
  width: 100% !important;
  margin: 0 !important;
  padding: 30px !important;
  box-sizing: border-box !important;
}

.rough-work-page {
  width: 100%;
  height: 100vh;
  page-break-after: always;
  padding: 40px;
  position: relative;
  z-index: 2;
}

.rough-work-title {
  font-family: 'Times New Roman', serif;
  font-size: 24pt;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #000;
  padding-bottom: 10px;
}

.rough-work-lines {
  height: calc(100% - 80px);
  background-image: repeating-linear-gradient(
    transparent,
    transparent 35px,
    #ccc 35px,
    #ccc 36px
  );
}

.print-container {
  width: 100%;
  font-family: 'Times New Roman', serif;
  font-size: 11pt;
  line-height: 1.4;
  position: relative;
  z-index: 2;
}

.print-container * {
  position: relative;
  z-index: 2;
}

.section-header-wrapper {
  column-span: all;
  -webkit-column-span: all;
  page-break-after: avoid;
  position: relative;
  z-index: 2;
}

.section-heading {
  font-size: 13pt;
  font-weight: 500;
  margin: 10px 0 5px 0;
  page-break-after: avoid;
  position: relative;
  z-index: 2;
}

.section-instruction {
  margin: 0 0 8px 0;
  page-break-after: avoid;
  position: relative;
  z-index: 2;
}

.subject-divider {
  page-break-before: always;
  column-span: all;
  -webkit-column-span: all;
}

.single-column .question-block {
  margin-bottom: 6px;
  page-break-inside: avoid;
  break-inside: avoid;
  position: relative;
  z-index: 2;
}

.single-column .question-text {
  margin: 0 0 2px 0;
  line-height: 1.3;
  page-break-after: avoid;
  position: relative;
  z-index: 2;
}

.single-column .options {
  margin-left: 20px;
  margin-bottom: 0;
  position: relative;
  z-index: 2;
}

.single-column .option-text {
  margin: 1px 0;
  font-size: 10.5pt;
  line-height: 1.2;
  position: relative;
  z-index: 2;
}

.twin-column .columned-content {
  column-count: 2;
  -webkit-column-count: 2;
  -moz-column-count: 2;
  column-gap: 20px;
  -webkit-column-gap: 20px;
  -moz-column-gap: 20px;
  column-rule: 2px solid #000;
  -webkit-column-rule: 2px solid #000;
  -moz-column-rule: 2px solid #000;
  column-fill: auto;
  -webkit-column-fill: auto;
  -moz-column-fill: auto;
  position: relative;
  z-index: 2;
}

.twin-column .question-text {
  margin: 6px 0 2px 0;
  line-height: 1.3;
  font-size: 10.5pt;
  page-break-after: avoid;
  break-after: avoid-column;
  orphans: 2;
  widows: 2;
  page-break-inside: avoid;
  break-inside: avoid;
  position: relative;
  z-index: 2;
}

.twin-column .option-text {
  margin: 1px 0 1px 15px;
  font-size: 10pt;
  line-height: 1.2;
  orphans: 2;
  widows: 2;
  position: relative;
  z-index: 2;
}

.twin-column .question-spacer {
  height: 4px;
  margin: 0;
  padding: 0;
}

.question-block img,
.options img,
.question-text img,
.option-text img {
  width: auto !important;
  height: auto !important;
  min-width: 40px !important;
  min-height: 40px !important;
  max-width: 85% !important;
  margin: 2px !important;
  vertical-align: middle !important;
  object-fit: contain !important;
  page-break-inside: avoid;
  position: relative !important;
  z-index: 2 !important;
}

.twin-column img {
  max-width: 75% !important;
}

p {
  orphans: 2;
  widows: 2;
}
    .all-set-wrapper .print-container::before {
    opacity: 0.025 !important;
    width: 420px;
    height: 420px;
  }
`}</style>
    </>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    padding: "20px",
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "12px",
    width: "90%",
    maxWidth: "700px",
    maxHeight: "50vh",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.3)",
    overflow: "hidden",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 18px",
    borderBottom: "1px solid #e0e0e0",
    backgroundColor: "#f8f9fa",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
  },
  title: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#666",
    padding: "0",
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "all 0.2s",
  },
  body: {
    padding: "25px",
    overflowY: "auto",
    flex: 1,
    backgroundColor: "#f8f9fa",
    border: "2px solid #e0e0e0",
    margin: "15px",
    borderRadius: "8px",
  },
  setSelectionContainer: {},
  sectionTitle: {
    margin: "0 0 15px 0",
    fontSize: "14px",
    fontWeight: "600",
    color: "#333",
  },
  radioGroup: {
    display: "flex",
    gap: "15px",
    flexWrap: "wrap",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    fontSize: "14px",
    padding: "10px 16px",
    borderRadius: "6px",
    transition: "all 0.2s",
    fontWeight: "500",
    minWidth: "70px",
    justifyContent: "center",
  },
  radio: {
    cursor: "pointer",
    width: "18px",
    height: "18px",
    accentColor: "#4CAF50",
  },
  radioText: {
    userSelect: "none",
  },
  optionsContainer: {
    borderRadius: "8px",
    marginTop: "10px",
  },
  checkboxGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "15px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    fontSize: "14px",
    padding: "8px 12px",
    borderRadius: "4px",
    transition: "all 0.2s",
  },
  checkbox: {
    cursor: "pointer",
    width: "18px",
    height: "18px",
    accentColor: "#c2c2c2ff",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "15px",
    marginBottom: "10px",
  },
  printButton: {
    padding: "12px 30px",
    fontSize: "14px",
    backgroundColor: "#ffffffff",
    color: "#0b0b0bb9",
    border: "1px solid black",
    cursor: "pointer",
    borderRadius: "6px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 4px 4px rgba(46, 45, 45, 0.3)",
    transition: "all 0.2s",
  },
  printIcon: {
    fontSize: "16px",
    color: "#595959c4",
  },
  spinner: {
    fontSize: "16px",
  },
};

export default TestPrintModal;
